<template>
  <div>
    <v-row v-if="!isMobilePlayer1 && !isMobilePlayer2 && !isMobilePlayer3">
      <v-col cols="4" class="mt-2">
        <v-row>
          <v-img :src="currentTrack.art" contain cover max-height="62px" min-width="62px" max-width="62px" class="album-art ml-6 mt-4"
            @click="this.loadLink(currentTrack)">
          </v-img> 
          <div class="track-info mt-2 ml-4">
            <div class="track-title" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 200px;
                max-width: 200px;
              ">
              <a v-if="currentTrack.type === 'muze' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'muze' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'geo'" :href="'https://verse.muzible.com/track/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/episode/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/podcast/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
            </div>
            <div style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 200px;
                max-width: 200px;
              ">
              <span v-for="(artist, index) in currentTrack.artists" :key="index">
                <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist }}</a>
                <span v-if="index < currentTrack.artists.length - 1">, </span>
              </span>
            </div>
            <div v-if="currentTrack.nft_is === 1" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 200px;
                max-width: 200px;
              ">
              <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
              </span>
              <span v-if="currentTrack.type === 'geo'" style="color: white">,
              </span>
              <span style="color: #f01ff0">NFT </span> by
              <a :href="'https://muze.muzible.com/creator/' + currentTrack.creator" class="artist-link">{{
                currentTrack.creator }}</a>
            </div>
            <div v-else style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 200px;
                max-width: 200px;">
                <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                </span>
            </div>
          </div>
          <div class="mt-4" style="overflow: visible">
            <v-row class="pt-0" justify="center">
              <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(currentTrack.id)" icon="mdi-star-outline"
                class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                style="color: white !important" @click="this.addToFav(currentTrack)">
              </v-btn>
              <v-btn v-else icon="mdi-star" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                style="color: #f0e556 !important" @click="this.removeFromFav(currentTrack)">
              </v-btn>

              <v-btn v-if="this.notinPlaylists(currentTrack.id)" icon="mdi-plus-circle-outline" class="open-playlist-btn pt-4"
                :ripple="false" density="compact" size="small" variant="plain" style="color: white !important"
                @click="this.openAddPlaylist(currentTrack)">
              </v-btn>
              <v-btn v-else icon="mdi-plus-circle" class="open-playlist-btn pt-4" :ripple="false" density="compact" size="small"
                variant="plain" style="color: #1ff050 !important" @click="this.openAddPlaylist(currentTrack)">
              </v-btn>
              <v-expand-transition @after-enter="loadingplaylist = true">
                <v-card v-if="showPlaylistDropdown" v-click-outside="clickedOutsidePlaylist" class="playlist-card-pl"
                  style="
                  position: absolute !important;
                  width: 270px !important;
                  height: 430px !important;
                ">
                  <v-card-text>
                    <v-text-field v-model="playlistSearchQuery" placeholder="Search in playlists" density="compact"
                      hide-details clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                      bg-color="black"></v-text-field>
                    <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                      <v-btn @click="this.createNewPlaylist(currentTrack)"
                        :disabled="userPlaylists.length > 99 || playlistcreation" class="menu-btn-close2"
                        style="border-radius: 10px" elevation="0" height="36px">
                        New playlist..
                      </v-btn>
                    </v-row>
                    <div>
                      <Transition name="fade2">
                        <div v-show="isPlaylistLoading" class="loading-spinner">
                          <v-progress-circular indeterminate color="white"></v-progress-circular>
                        </div>
                      </Transition>
                      <Transition name="fade2">
                        <div v-if="loadingplaylist">
                          <v-list v-show="!isPlaylistLoading" ref="playlistList" @scroll.passive="onScroll" style="
                            max-height: 348px;
                            overflow-y: scroll;
                            background-color: black;
                            color: white;
                          ">
                            <v-list-item v-for="playlist in getVisiblePlaylists" :key="playlist.id"
                              style="cursor: pointer" @click="this.toggleTrackInPlaylist(playlist)">
                              <v-hover>
                                <template v-slot:default="{ isHovering, props }">
                                  <div v-bind="props" class="pa-0 ma-0">
                                    <v-row v-if="playlist.tracks.length < 150" class="pa-0 ma-0">
                                      <v-col cols="10" class="pa-0 ma-0">
                                        <v-row justify="start" class="pa-0 ma-0">
                                          <v-col cols="2" class="pa-0 ma-0">
                                            <v-img @click.stop="
                                              this.addFullTracksToPlay(playlist)
                                              " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                              class="album-art2">
                                              <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                size="30px">mdi-playlist-play</v-icon>
                                            </v-img>
                                          </v-col>
                                          <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                            <div style="
                                              white-space: nowrap;
                                              overflow: hidden;
                                              text-overflow: ellipsis;
                                              max-width: 150px;
                                            ">
                                              <span class="mt-1 pl-2">{{
                                                playlist.name
                                                }}</span>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                        <span>
                                          <v-icon v-if="
                                            playlist.tracks.includes(
                                              currentTrackToAdd.id
                                            )
                                          " color="#1ff050">
                                            mdi-checkbox-marked-circle
                                          </v-icon>
                                          <v-icon v-else color="white">
                                            mdi-checkbox-blank-circle-outline
                                          </v-icon>
                                        </span>
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="playlist.tracks.length >= 150" class="pa-0 ma-0">
                                      <v-col cols="10" class="pa-0 ma-0">
                                        <v-row justify="start" class="pa-0 ma-0">
                                          <v-col cols="2" class="pa-0 ma-0">
                                            <v-img @click.stop="
                                              this.addFullTracksToPlay(playlist)
                                              " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                              class="album-art2">
                                              <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                size="30px">mdi-playlist-play</v-icon>
                                            </v-img>
                                          </v-col>
                                          <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                            <div v-show="!isHovering ||
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                              " style="
                                              white-space: nowrap;
                                              overflow: hidden;
                                              text-overflow: ellipsis;
                                              max-width: 150px;
                                            ">
                                              <span class="mt-1 pl-2">{{
                                                playlist.name
                                                }}</span>
                                            </div>
                                            <div v-show="isHovering &&
                                              !playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                              " style="overflow: hidden" class="overlay-pl pa-0 ma-0 ml-2">
                                              <span class="overlay-text-pl pa-0">Playlist Full</span>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                        <span>
                                          <v-icon v-if="
                                            playlist.tracks.includes(
                                              currentTrackToAdd.id
                                            )
                                          " color="#1ff050">
                                            mdi-checkbox-marked-circle
                                          </v-icon>
                                          <v-icon v-else color="white">
                                            mdi-close-circle-outline
                                          </v-icon>
                                        </span>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </template>
                              </v-hover>
                            </v-list-item>
                          </v-list>
                        </div>
                      </Transition>
                    </div>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
            </v-row>
            <v-row class="pa-0 ma-0 pt-2" justify="center">
              <v-btn v-show="!this.sorroundloaded" class="pt-4" :disabled="true" :ripple="false" density="compact"
                size="small" variant="plain" style="color: white !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="this.sorroundloaded" class="pt-4" :disabled="true" :ripple="false" density="compact"
                size="small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="!this.atmosdetected" class="pt-4" :disabled="true" :ripple="false" density="compact"
                size="small" variant="plain" style="color: white !important" icon="mdi-surround-sound">
              </v-btn>
              <v-btn v-show="this.atmosdetected" class="pt-4" :disabled="true" :ripple="false" density="compact"
                size="small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound">
              </v-btn>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="6" class="mt-0">
        <v-row justify="center" class="mt-0">
          <v-btn v-show="this.currentQuality === -1" icon="mdi-signal-cellular-outline" class="pt-4" :ripple="false"
            density="compact" size="small" variant="plain" :disabled="true" style="color: grey !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 0" icon="mdi-signal-cellular-1" class="pt-4" :ripple="false"
            density="compact" size="small" variant="plain" :disabled="true" style="color: #E34234 !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 1" icon="mdi-signal-cellular-2" class="pt-4" :ripple="false"
            density="compact" size="small" variant="plain" :disabled="true" style="color: yellow !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 2" icon="mdi-signal-cellular-3" class="pt-4" :ripple="false"
            density="compact" size="small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 3" icon="mdi-signal-cellular-3" class="pt-4" :ripple="false"
            density="compact" size="small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn :icon="repeatModeIcon" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
            style="color: white !important" @click="this.toggleRepeat()">
          </v-btn>
          <v-btn density="compact" class="pt-4" :ripple="false" icon="mdi-rewind-15" variant="plain" size="small"
            style="color: white !important" @click="this.rewind15()">
          </v-btn>
          <v-btn density="compact" class="pt-4" :ripple="false" :disabled="ismusicloading" icon="mdi-skip-previous"
            variant="plain" size="small" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.prevTrack();
            ">
          </v-btn>
          <v-btn v-if="isPlaying" :ripple="false" density="compact" icon="mdi-pause" variant="plain" size="large"
            style="color: white !important" @click="this.togglePlayPause()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="currentTrackInfo === 1" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 42px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="
                    currentTrack.type === 'geo'
                  " style="color: #f0e556">GEO</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type === 'geo'
                  " style="color: #f01ff0">&nbsp;NFT</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type !== 'geo'
                  " style="color: #f01ff0">NFT</span>
                  <span v-if="currentTrack.stream_lvl > user.level" style="color: #e34234">
                    &nbsp;Plan upgrade required or creator subscription</span>
                  <span v-if="this.geoOwnerOnly" style="color: #e34234">&nbsp; Music in location restricted to NFT owners</span>
                </v-row>
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="this.geoPassed" style="color: #e34234">Music not available anymore in this location</span>
                  <span v-else style="color: #e34234">Not allowed to play full track, only preview available</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-expand-transition>
            <v-card v-if="this.hlsProblem" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 22px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span style="color: #e34234">Stream error, downgraded to lower quality..</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn v-if="!isPlaying" :ripple="false" density="compact" icon="mdi-play-circle" variant="plain" size="large"
            style="color: white !important" :disabled="usehls && hlsready === false && this.playHLScheck(this.currentTrack)
              " @click="this.togglePlayPause()">
          </v-btn>
          <v-btn icon="mdi-skip-next" class="pt-4" :ripple="false" :disabled="ismusicloading" density="compact"
            size="small" variant="plain" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.nextTrack();
            ">
          </v-btn>
          <v-btn icon="mdi-fast-forward-15" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
            style="color: white !important" @click="this.fastForward15()">
          </v-btn>
          <v-btn class="pt-6 pr-0 mr-0" :disabled="true" :ripple="false" density="compact" size="x-small" variant="plain">
            <img v-show="this.dolbydetected" width="45px" :src="require('@/assets/logo/dolby_on.png')" />
            <img v-show="!this.dolbydetected" width="45px" :src="require('@/assets/logo/dolby.png')" />
          </v-btn>
          <v-btn class="pt-6 pl-0 ml-0 pr-0 mr-0" :disabled="true" :ripple="false" density="compact" size="x-small"
            variant="plain">
            <v-img v-show="this.flacEnabled" width="20px" :src="require('@/assets/icons/flac_green.svg')"></v-img>
            <v-img v-show="!this.flacEnabled" width="20px" :src="require('@/assets/icons/flac.svg')"></v-img>
          </v-btn>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="1" align="end" class="pa-0 ma-0 mt-2 pr-2">
            <span class="track-info">{{ formatTime(currentTime) }}</span>
          </v-col>
          <v-col v-if="currentTrackInfo === 0" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#1ff050" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col v-if="currentTrackInfo === 1" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#E34234" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col cols="1" class="pa-0 ma-0 mt-2 pl-2">
            <span class="track-info mt-3">{{ formatTime(duration) }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2" class="mt-0">
        <v-row justify="center" class="mt-1">
          <v-btn icon="mdi-playlist-music" class="open-tracks-btn pt-0 pa-0 ma-0 ml-0" :ripple="false" density="compact" variant="plain"
            style="color: white !important" @click="openTracklist">
          </v-btn>
          <v-expand-transition @after-enter="loadingdata = true">
            <v-card v-if="showTrackDropdown" v-click-outside="clickedOutsideTracks" class="playlist-card-tracks" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="trackSearchQuery" placeholder="Search in queue" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="tracks.length === 0" @click="this.shuffleTracks()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Shuffle everything..
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isTrackLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingdata">
                      <v-list v-show="!isTrackLoading" ref="tracksList" @scroll.passive="onScrollTracks" style="
                          max-height: 348px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="(track, index) in getVisibleTracks" :key="index">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="
                                          this.playOrPauseSongTracks(
                                            track,
                                            track.originalIndex
                                          )
                                          " :src="track.art" contain cover max-height="30px" max-width="30px"
                                          class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(track)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                                                                  <a v-if="
                                            track.type === 'podcast' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'podcast' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon :disabled="tracks.length === 1 ||
                                        (ismusicloading &&
                                          this.ifCurrentMusicNow(track) &&
                                          track.originalIndex ===
                                          currentTrackIndex &&
                                          this.queueremoval)
                                        " @click="
                                          this.queueremoval = true;
                                        this.removeFromQueue(
                                          track,
                                          track.originalIndex
                                        );
                                        " class="simple-icon" color="white">
                                        mdi-playlist-minus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-star" class="open-favs-btn pt-0 pa-0 ma-0" :ripple="false" density="compact" variant="plain"
            style="color: #f0e556 !important" @click="this.openFavs()">
          </v-btn>
          <v-expand-transition @after-enter="loadingfavs = true">
            <v-card v-if="showFavsDropdown" v-click-outside="clickedOutsideFavs" class="playlist-card-fav" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="favsSearchQuery" placeholder="Search in favourites" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="userFavSongs.length === 0" @click="this.addAllFavsToQueue()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Queue all..
                  </v-btn>
                  <v-btn :disabled="userFavSongs.length === 0 || ismusicloading" @click="this.addAllFavsToEmptyQueue()"
                    class="menu-btn-close2 mt-1" style="border-radius: 10px" elevation="0" height="36px">
                    Play all
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isFavsLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingfavs">
                      <v-list v-show="!isFavsLoading" ref="favsList" @scroll.passive="onScrollFavs" style="
                          max-height: 302px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="fav in getVisibleFavs" :key="fav.id">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="this.playOrPauseSong(fav)" :src="fav.art" contain cover
                                          max-height="30px" max-width="30px" class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            !this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(fav)
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                                                                  <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon @click="this.addtoQueue(fav)" class="simple-icon" color="white">
                                        mdi-playlist-plus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-plus" class="open-search-btn pt-0 pa-0 ma-0 mr-0" :ripple="false" density="compact" variant="plain"
            style="color: #1ff050 !important" @click="this.openSearch()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="showSearchDropdown" v-click-outside="clickedOutsideSearch" class="playlist-card-search" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 83px) !important;
              ">
              <v-card-item>
                <MusicSearch/>
              </v-card-item>
            </v-card>
          </v-expand-transition>
        </v-row>
        <v-row justify="center" align="center" class="mt-2">
          <v-btn :icon="volume === 0 ? 'mdi-volume-mute' : 'mdi-volume-high'" :ripple="false" density="compact"
            size="small" variant="plain" style="color: white !important" @click="this.toggleMute()"
            class="mr-0 pr-0 pb-5">
          </v-btn>
          <v-slider v-model="volume" step="1" min="0" max="100" color="#1ff050" :thumb-size="10" thumb-color="white"
            track-color="grey" class="progeess-bar pr-8 pl-0 ml-0" @end="this.changeVolume()"></v-slider>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="isMobilePlayer1 && !isMobilePlayer2 && !isMobilePlayer3">
      <v-col cols="4" class="mt-2">
        <v-row>
          <v-img :src="currentTrack.art" contain cover max-height="62px" min-width="62px" max-width="62px" class="album-art ml-6 mt-4"
            @click="this.loadLink(currentTrack)">
          </v-img> 
          <div class="track-info mt-2 ml-4">
            <div class="track-title" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 100px;
                max-width: 100px;
              ">
              <a v-if="currentTrack.type === 'muze' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'muze' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'geo'" :href="'https://verse.muzible.com/track/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/episode/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/podcast/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
            </div>
            <div style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 100px;
                max-width: 100px;
              ">
              <span v-for="(artist, index) in currentTrack.artists" :key="index">
                <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist }}</a>
                <span v-if="index < currentTrack.artists.length - 1">, </span>
              </span>
            </div>
            <div v-if="currentTrack.nft_is === 1" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 100px;
                max-width: 100px;
              ">
              <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
              </span>
              <span v-if="currentTrack.type === 'geo'" style="color: white">,
              </span>
              <span style="color: #f01ff0">NFT </span> by
              <a :href="'https://muze.muzible.com/creator/' + currentTrack.creator" class="artist-link">{{
                currentTrack.creator }}</a>
            </div>
            <div v-else style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 100px;
                max-width: 100px;">
                <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                </span>
            </div>
          </div>
          <div class="mt-4" style="overflow: visible">
              <v-row class="pt-0" justify="center">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(currentTrack.id)" icon="mdi-star-outline"
                  class="pt-6" :ripple="false" density="compact" size="x-small" variant="plain"
                  style="color: white !important" @click="this.addToFav(currentTrack)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-6" :ripple="false" density="compact" size="x-small" variant="plain"
                  style="color: #f0e556 !important" @click="this.removeFromFav(currentTrack)">
                </v-btn>

                <v-btn v-if="this.notinPlaylists(currentTrack.id)" icon="mdi-plus-circle-outline" class="open-playlist-btn pt-6"
                  :ripple="false" density="compact" size="x-small" variant="plain" style="color: white !important"
                  @click="this.openAddPlaylist(currentTrack)">
                </v-btn>
                <v-btn v-else icon="mdi-plus-circle" class="open-playlist-btn pt-6" :ripple="false" density="compact" size="x-small"
                  variant="plain" style="color: #1ff050 !important" @click="this.openAddPlaylist(currentTrack)">
                </v-btn>
                <v-expand-transition @after-enter="loadingplaylist = true">
                  <v-card v-if="showPlaylistDropdown" v-click-outside="clickedOutsidePlaylist" class="playlist-card-pl"
                    style="
                    position: absolute !important;
                    width: 270px !important;
                    height: 430px !important;
                  ">
                    <v-card-text>
                      <v-text-field v-model="playlistSearchQuery" placeholder="Search in playlists" density="compact"
                        hide-details clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                        bg-color="black"></v-text-field>
                      <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                        <v-btn @click="this.createNewPlaylist(currentTrack)"
                          :disabled="userPlaylists.length > 99 || playlistcreation" class="menu-btn-close2"
                          style="border-radius: 10px" elevation="0" height="36px">
                          New playlist..
                        </v-btn>
                      </v-row>
                      <div>
                        <Transition name="fade2">
                          <div v-show="isPlaylistLoading" class="loading-spinner">
                            <v-progress-circular indeterminate color="white"></v-progress-circular>
                          </div>
                        </Transition>
                        <Transition name="fade2">
                          <div v-if="loadingplaylist">
                            <v-list v-show="!isPlaylistLoading" ref="playlistList" @scroll.passive="onScroll" style="
                              max-height: 348px;
                              overflow-y: scroll;
                              background-color: black;
                              color: white;
                            ">
                              <v-list-item v-for="playlist in getVisiblePlaylists" :key="playlist.id"
                                style="cursor: pointer" @click="this.toggleTrackInPlaylist(playlist)">
                                <v-hover>
                                  <template v-slot:default="{ isHovering, props }">
                                    <div v-bind="props" class="pa-0 ma-0">
                                      <v-row v-if="playlist.tracks.length < 150" class="pa-0 ma-0">
                                        <v-col cols="10" class="pa-0 ma-0">
                                          <v-row justify="start" class="pa-0 ma-0">
                                            <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                                class="album-art2">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="30px">mdi-playlist-play</v-icon>
                                              </v-img>
                                            </v-col>
                                            <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                              <div style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 150px;
                                              ">
                                                <span class="mt-1 pl-2">{{
                                                  playlist.name
                                                  }}</span>
                                              </div>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white">
                                              mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                      <v-row v-if="playlist.tracks.length >= 150" class="pa-0 ma-0">
                                        <v-col cols="10" class="pa-0 ma-0">
                                          <v-row justify="start" class="pa-0 ma-0">
                                            <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                                class="album-art2">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="30px">mdi-playlist-play</v-icon>
                                              </v-img>
                                            </v-col>
                                            <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                              <div v-show="!isHovering ||
                                                playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 150px;
                                              ">
                                                <span class="mt-1 pl-2">{{
                                                  playlist.name
                                                  }}</span>
                                              </div>
                                              <div v-show="isHovering &&
                                                !playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="overflow: hidden" class="overlay-pl pa-0 ma-0 ml-2">
                                                <span class="overlay-text-pl pa-0">Playlist Full</span>
                                              </div>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white">
                                              mdi-close-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-hover>
                              </v-list-item>
                            </v-list>
                          </div>
                        </Transition>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expand-transition>
              </v-row>
              <v-row class="pa-0 ma-0 pt-2" justify="center">
              <v-btn v-show="!this.sorroundloaded" class="pt-6" :disabled="true" :ripple="false" density="compact"
                size="x-small" variant="plain" style="color: white !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="this.sorroundloaded" class="pt-6" :disabled="true" :ripple="false" density="compact"
                size="x-small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="!this.atmosdetected" class="pt-6" :disabled="true" :ripple="false" density="compact"
                size="x-small" variant="plain" style="color: white !important" icon="mdi-surround-sound">
              </v-btn>
              <v-btn v-show="this.atmosdetected" class="pt-6" :disabled="true" :ripple="false" density="compact"
                size="x-small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound">
              </v-btn>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="6" class="mt-0">
        <v-row justify="center" class="mt-0">
          <v-btn v-show="this.currentQuality === -1" icon="mdi-signal-cellular-outline" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: grey !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 0" icon="mdi-signal-cellular-1" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: #E34234 !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 1" icon="mdi-signal-cellular-2" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: yellow !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 2" icon="mdi-signal-cellular-3" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 3" icon="mdi-signal-cellular-3" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn :icon="repeatModeIcon" class="pt-5 ml-0 pl-0 mr-0 pr-0 pr-8" :ripple="false" density="compact" :stacked="false" size="x-small" variant="plain"
            style="color: white !important" @click="this.toggleRepeat()">
          </v-btn>
          <v-btn density="compact" class="pt-5 ml-0 pl-0 mr-0 pr-0 pr-8" :ripple="false" icon="mdi-rewind-15" :stacked="false" variant="plain" size="x-small"
            style="color: white !important" @click="this.rewind15()">
          </v-btn>
          <v-btn density="compact" class="pt-5 ml-0 pl-0 mr-0 pr-0" :ripple="false" :disabled="ismusicloading" :stacked="false" icon="mdi-skip-previous"
            variant="plain" size="x-small" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.prevTrack();
            ">
          </v-btn>
          <v-btn v-if="isPlaying" :ripple="false" density="compact" class="ml-0 pl-0 mr-0 pr-0" icon="mdi-pause" variant="plain" size="large"
            style="color: white !important" @click="this.togglePlayPause()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="currentTrackInfo === 1" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 42px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="
                    currentTrack.type === 'geo'
                  " style="color: #f0e556">GEO</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type === 'geo'
                  " style="color: #f01ff0">&nbsp;NFT</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type !== 'geo'
                  " style="color: #f01ff0">NFT</span>
                  <span v-if="currentTrack.stream_lvl > user.level" style="color: #e34234">
                    &nbsp;Plan upgrade required or creator subscription</span>
                  <span v-if="this.geoOwnerOnly" style="color: #e34234">&nbsp; Music in location restricted to NFT owners</span>
                </v-row>
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="this.geoPassed" style="color: #e34234">Music not available anymore in this location</span>
                  <span v-else style="color: #e34234">Not allowed to play full track, only preview available</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-expand-transition>
            <v-card v-if="this.hlsProblem" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 22px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span style="color: #e34234">Stream error, downgraded to lower quality..</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn v-if="!isPlaying" :ripple="false" class="ml-0 pl-0 mr-0 pr-0" density="compact" icon="mdi-play-circle" variant="plain" size="large"
            style="color: white !important" :disabled="usehls && hlsready === false && this.playHLScheck(this.currentTrack)
              " @click="this.togglePlayPause()">
          </v-btn>
          <v-btn icon="mdi-skip-next" class="pt-5 ml-0 pl-0 mr-0 pr-8" :ripple="false" :stacked="false" :disabled="ismusicloading" density="compact"
            size="x-small" variant="plain" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.nextTrack();
            ">
          </v-btn>
          <v-btn icon="mdi-fast-forward-15" class="pt-5 ml-0 pl-0 mr-0 pr-6" :stacked="false" :ripple="false" density="compact" size="x-small" variant="plain"
            style="color: white !important" @click="this.fastForward15()">
          </v-btn>
          <v-btn class="pt-6 pr-0 mr-0 pr-4" :disabled="true" :ripple="false" density="compact" :stacked="false" size="x-small" variant="plain">
            <img v-show="this.dolbydetected" width="35px" :src="require('@/assets/logo/dolby_on.png')" />
            <img v-show="!this.dolbydetected" width="35px" :src="require('@/assets/logo/dolby.png')" />
          </v-btn>
          <v-btn class="pt-5 pl-0 ml-0 pr-0 mr-0" :disabled="true" :ripple="false" :stacked="false" density="compact" size="x-small"
            variant="plain">
            <v-img v-show="this.flacEnabled" width="18px" :src="require('@/assets/icons/flac_green.svg')"></v-img>
            <v-img v-show="!this.flacEnabled" width="18px" :src="require('@/assets/icons/flac.svg')"></v-img>
          </v-btn>
        </v-row>
        <v-row justify="center" class="mt-0">
          <v-col cols="1" align="end" class="pa-0 ma-0 mt-2 pr-2">
            <span class="track-info">{{ formatTime(currentTime) }}</span>
          </v-col>
          <v-col v-if="currentTrackInfo === 0" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#1ff050" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col v-if="currentTrackInfo === 1" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#E34234" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col cols="1" class="pa-0 ma-0 mt-2 pl-2">
            <span class="track-info mt-3">{{ formatTime(duration) }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2" class="mt-0">
        <v-row justify="center" class="mt-1">
          <v-btn icon="mdi-playlist-music" class="open-tracks-btn pt-4 pa-0 ma-0 ml-0" :ripple="false" size="x-small" density="compact" variant="plain"
            style="color: white !important" @click="openTracklist">
          </v-btn>
          <v-expand-transition @after-enter="loadingdata = true">
            <v-card v-if="showTrackDropdown" v-click-outside="clickedOutsideTracks" class="playlist-card-tracks" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="trackSearchQuery" placeholder="Search in queue" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="tracks.length === 0" @click="this.shuffleTracks()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Shuffle everything..
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isTrackLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingdata">
                      <v-list v-show="!isTrackLoading" ref="tracksList" @scroll.passive="onScrollTracks" style="
                          max-height: 348px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="(track, index) in getVisibleTracks" :key="index">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="
                                          this.playOrPauseSongTracks(
                                            track,
                                            track.originalIndex
                                          )
                                          " :src="track.art" contain cover max-height="30px" max-width="30px"
                                          class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(track)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                                                                  <a v-if="
                                            track.type === 'podcast' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'podcast' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon :disabled="tracks.length === 1 ||
                                        (ismusicloading &&
                                          this.ifCurrentMusicNow(track) &&
                                          track.originalIndex ===
                                          currentTrackIndex &&
                                          this.queueremoval)
                                        " @click="
                                          this.queueremoval = true;
                                        this.removeFromQueue(
                                          track,
                                          track.originalIndex
                                        );
                                        " class="simple-icon" color="white">
                                        mdi-playlist-minus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-star" class="open-favs-btn pt-4 pa-0 ma-0" :ripple="false" size="x-small" density="compact" variant="plain"
            style="color: #f0e556 !important" @click="this.openFavs()">
          </v-btn>
          <v-expand-transition @after-enter="loadingfavs = true">
            <v-card v-if="showFavsDropdown" v-click-outside="clickedOutsideFavs" class="playlist-card-fav" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="favsSearchQuery" placeholder="Search in favourites" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="userFavSongs.length === 0" @click="this.addAllFavsToQueue()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Queue all..
                  </v-btn>
                  <v-btn :disabled="userFavSongs.length === 0 || ismusicloading" @click="this.addAllFavsToEmptyQueue()"
                    class="menu-btn-close2 mt-1" style="border-radius: 10px" elevation="0" height="36px">
                    Play all
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isFavsLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingfavs">
                      <v-list v-show="!isFavsLoading" ref="favsList" @scroll.passive="onScrollFavs" style="
                          max-height: 302px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="fav in getVisibleFavs" :key="fav.id">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="this.playOrPauseSong(fav)" :src="fav.art" contain cover
                                          max-height="30px" max-width="30px" class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            !this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(fav)
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                                                                  <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon @click="this.addtoQueue(fav)" class="simple-icon" color="white">
                                        mdi-playlist-plus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-plus" class="open-search-btn pt-4 pa-0 ma-0 mr-0" :ripple="false" size="x-small" density="compact" variant="plain"
            style="color: #1ff050 !important" @click="this.openSearch()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="showSearchDropdown" v-click-outside="clickedOutsideSearch" class="playlist-card-search" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 83px) !important;
              ">
              <v-card-item>
                <MusicSearch/>
              </v-card-item>
            </v-card>
          </v-expand-transition>
        </v-row>
        <v-row justify="center" align="center" class="mt-6">
          <v-btn :icon="volume === 0 ? 'mdi-volume-mute' : 'mdi-volume-high'" :ripple="false" density="compact"
            size="small" variant="plain" style="color: white !important" @click="this.toggleMute()"
            class="mr-0 pr-0 pb-5">
          </v-btn>
          <v-slider v-model="volume" step="1" min="0" max="100" color="#1ff050" :thumb-size="10" thumb-color="white"
            track-color="grey" class="progeess-bar pr-8 pl-0 ml-0" @end="this.changeVolume()"></v-slider>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="isMobilePlayer1 && isMobilePlayer2 && !isMobilePlayer3">
      <v-col cols="4" class="mt-2">
        <v-row>
          <v-img :src="currentTrack.art" contain cover max-height="62px" min-width="62px" max-width="62px" class="album-art ml-6 mt-4"
            @click="this.loadLink(currentTrack)">
          </v-img> 
          <div class="track-info mt-2 ml-4">
            <div class="track-title" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 80px;
                max-width: 80px;
              ">
              <a v-if="currentTrack.type === 'muze' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'muze' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'geo'" :href="'https://verse.muzible.com/track/' + currentTrack.id"
                class="artist-link">{{ currentTrack.title }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/track/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'global' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/album/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album === ''"
                :href="'https://muze.muzible.com/episode/' + currentTrack.id" class="artist-link">{{ currentTrack.title
                }}</a>
              <a v-if="currentTrack.type === 'podcast' && currentTrack.album !== ''"
                :href="'https://muze.muzible.com/podcast/' + currentTrack.album" class="artist-link">{{ currentTrack.title
                }}</a>
            </div>
            <div style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 80px;
                max-width: 80px;
              ">
              <span v-for="(artist, index) in currentTrack.artists" :key="index">
                <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist }}</a>
                <span v-if="index < currentTrack.artists.length - 1">, </span>
              </span>
            </div>
            <div v-if="currentTrack.nft_is === 1" style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 80px;
                max-width: 80px;
              ">
              <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
              </span>
              <span v-if="currentTrack.type === 'geo'" style="color: white">,
              </span>
              <span style="color: #f01ff0">NFT </span> by
              <a :href="'https://muze.muzible.com/creator/' + currentTrack.creator" class="artist-link">{{
                currentTrack.creator }}</a>
            </div>
            <div v-else style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 80px;
                max-width: 80px;">
                <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                </span>
            </div>
          </div>
          <div class="mt-4" style="overflow: visible">
              <v-row class="pt-0" justify="center">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(currentTrack.id)" icon="mdi-star-outline"
                  class="pt-5 pl-4" :ripple="false" density="compact" size="x-small" variant="plain"  :stacked="false"
                  style="color: white !important" @click="this.addToFav(currentTrack)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-5 pl-4" :ripple="false" density="compact" size="x-small" variant="plain"  :stacked="false"
                  style="color: #f0e556 !important" @click="this.removeFromFav(currentTrack)">
                </v-btn>

                <v-btn v-if="this.notinPlaylists(currentTrack.id)" icon="mdi-plus-circle-outline" class="open-playlist-btn pt-5 pl-8"  :stacked="false"
                  :ripple="false" density="compact" size="x-small" variant="plain" style="color: white !important"
                  @click="this.openAddPlaylist(currentTrack)">
                </v-btn>
                <v-btn v-else icon="mdi-plus-circle" class="open-playlist-btn pt-5 pl-8" :ripple="false" density="compact" size="x-small"  :stacked="false"
                  variant="plain" style="color: #1ff050 !important" @click="this.openAddPlaylist(currentTrack)">
                </v-btn>
                <v-expand-transition @after-enter="loadingplaylist = true">
                  <v-card v-if="showPlaylistDropdown" v-click-outside="clickedOutsidePlaylist" class="playlist-card-pl"
                    style="
                    position: absolute !important;
                    width: 270px !important;
                    height: 430px !important;
                  ">
                    <v-card-text>
                      <v-text-field v-model="playlistSearchQuery" placeholder="Search in playlists" density="compact"
                        hide-details clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                        bg-color="black"></v-text-field>
                      <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                        <v-btn @click="this.createNewPlaylist(currentTrack)"
                          :disabled="userPlaylists.length > 99 || playlistcreation" class="menu-btn-close2"
                          style="border-radius: 10px" elevation="0" height="36px">
                          New playlist..
                        </v-btn>
                      </v-row>
                      <div>
                        <Transition name="fade2">
                          <div v-show="isPlaylistLoading" class="loading-spinner">
                            <v-progress-circular indeterminate color="white"></v-progress-circular>
                          </div>
                        </Transition>
                        <Transition name="fade2">
                          <div v-if="loadingplaylist">
                            <v-list v-show="!isPlaylistLoading" ref="playlistList" @scroll.passive="onScroll" style="
                              max-height: 348px;
                              overflow-y: scroll;
                              background-color: black;
                              color: white;
                            ">
                              <v-list-item v-for="playlist in getVisiblePlaylists" :key="playlist.id"
                                style="cursor: pointer" @click="this.toggleTrackInPlaylist(playlist)">
                                <v-hover>
                                  <template v-slot:default="{ isHovering, props }">
                                    <div v-bind="props" class="pa-0 ma-0">
                                      <v-row v-if="playlist.tracks.length < 150" class="pa-0 ma-0">
                                        <v-col cols="10" class="pa-0 ma-0">
                                          <v-row justify="start" class="pa-0 ma-0">
                                            <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                                class="album-art2">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="30px">mdi-playlist-play</v-icon>
                                              </v-img>
                                            </v-col>
                                            <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                              <div style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 150px;
                                              ">
                                                <span class="mt-1 pl-2">{{
                                                  playlist.name
                                                  }}</span>
                                              </div>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white">
                                              mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                      <v-row v-if="playlist.tracks.length >= 150" class="pa-0 ma-0">
                                        <v-col cols="10" class="pa-0 ma-0">
                                          <v-row justify="start" class="pa-0 ma-0">
                                            <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="30px" max-width="30px"
                                                class="album-art2">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="30px">mdi-playlist-play</v-icon>
                                              </v-img>
                                            </v-col>
                                            <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                              <div v-show="!isHovering ||
                                                playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 150px;
                                              ">
                                                <span class="mt-1 pl-2">{{
                                                  playlist.name
                                                  }}</span>
                                              </div>
                                              <div v-show="isHovering &&
                                                !playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="overflow: hidden" class="overlay-pl pa-0 ma-0 ml-2">
                                                <span class="overlay-text-pl pa-0">Playlist Full</span>
                                              </div>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white">
                                              mdi-close-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-hover>
                              </v-list-item>
                            </v-list>
                          </div>
                        </Transition>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expand-transition>
              </v-row>
              <v-row class="pa-0 ma-0 pt-2" justify="center">
              <v-btn v-show="!this.sorroundloaded" class="pt-7 pl-4" :disabled="true" :ripple="false" density="compact"  :stacked="false"
                size="x-small" variant="plain" style="color: white !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="this.sorroundloaded" class="pt-7 pl-4" :disabled="true" :ripple="false" density="compact"  :stacked="false"
                size="x-small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound-5-1">
              </v-btn>
              <v-btn v-show="!this.atmosdetected" class="pt-7 pl-8" :disabled="true" :ripple="false" density="compact"  :stacked="false"
                size="x-small" variant="plain" style="color: white !important" icon="mdi-surround-sound">
              </v-btn>
              <v-btn v-show="this.atmosdetected" class="pt-7 pl-8" :disabled="true" :ripple="false" density="compact"  :stacked="false"
                size="x-small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound">
              </v-btn>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="6" class="mt-0">
        <v-row justify="center" class="mt-0">
          <v-btn v-show="this.currentQuality === -1" icon="mdi-signal-cellular-outline" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: grey !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 0" icon="mdi-signal-cellular-1" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: #E34234 !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 1" icon="mdi-signal-cellular-2" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: yellow !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 2" icon="mdi-signal-cellular-3" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn v-show="this.currentQuality === 3" icon="mdi-signal-cellular-3" class="pt-5 pr-8" :ripple="false" :stacked="false"
            density="compact" size="x-small" variant="plain" :disabled="true" style="color: green !important">
          </v-btn>
          <v-btn :icon="repeatModeIcon" class="pt-5 ml-0 pl-0 mr-0 pr-0 pr-8" :ripple="false" density="compact" :stacked="false" size="x-small" variant="plain"
            style="color: white !important" @click="this.toggleRepeat()">
          </v-btn>
          <v-btn density="compact" class="pt-5 ml-0 pl-0 mr-0 pr-0 pr-8" :ripple="false" icon="mdi-rewind-15" :stacked="false" variant="plain" size="x-small"
            style="color: white !important" @click="this.rewind15()">
          </v-btn>
          <v-btn density="compact" class="pt-5 ml-0 pl-0 mr-0 pr-0" :ripple="false" :disabled="ismusicloading" :stacked="false" icon="mdi-skip-previous"
            variant="plain" size="x-small" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.prevTrack();
            ">
          </v-btn>
          <v-btn v-if="isPlaying" :ripple="false" density="compact" class="ml-0 pl-0 mr-0 pr-0" icon="mdi-pause" variant="plain" size="large"
            style="color: white !important" @click="this.togglePlayPause()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="currentTrackInfo === 1" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 42px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="
                    currentTrack.type === 'geo'
                  " style="color: #f0e556">GEO</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type === 'geo'
                  " style="color: #f01ff0">&nbsp;NFT</span>
                  <span v-if="
                    currentTrack.nft_is === 1 && currentTrack.type !== 'geo'
                  " style="color: #f01ff0">NFT</span>
                  <span v-if="currentTrack.stream_lvl > user.level" style="color: #e34234">
                    &nbsp;Plan upgrade required or creator subscription</span>
                  <span v-if="this.geoOwnerOnly" style="color: #e34234">&nbsp; Music in location restricted to NFT owners</span>
                </v-row>
                <v-row justify="center" class="pa-0 ma-0">
                  <span v-if="this.geoPassed" style="color: #e34234">Music not available anymore in this location</span>
                  <span v-else style="color: #e34234">Not allowed to play full track, only preview available</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-expand-transition>
            <v-card v-if="this.hlsProblem" class="playlist-card-noplay" style="
                position: absolute !important;
                width: 340px !important;
                height: 22px !important;
              ">
              <v-card-text v-if="user">
                <v-row justify="center" class="pa-0 ma-0">
                  <span style="color: #e34234">Stream error, downgraded to lower quality..</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn v-if="!isPlaying" :ripple="false" class="ml-0 pl-0 mr-0 pr-0" density="compact" icon="mdi-play-circle" variant="plain" size="large"
            style="color: white !important" :disabled="usehls && hlsready === false && this.playHLScheck(this.currentTrack)
              " @click="this.togglePlayPause()">
          </v-btn>
          <v-btn icon="mdi-skip-next" class="pt-5 ml-0 pl-0 mr-0 pr-8" :ripple="false" :stacked="false" :disabled="ismusicloading" density="compact"
            size="x-small" variant="plain" style="color: white !important" @click="
              this.$store.dispatch('setIsMusicLoading', true);
            this.nextTrack();
            ">
          </v-btn>
          <v-btn icon="mdi-fast-forward-15" class="pt-5 ml-0 pl-0 mr-0 pr-6" :stacked="false" :ripple="false" density="compact" size="x-small" variant="plain"
            style="color: white !important" @click="this.fastForward15()">
          </v-btn>
          <v-btn class="pt-6 pr-0 mr-0 pr-4" :disabled="true" :ripple="false" density="compact" :stacked="false" size="x-small" variant="plain">
            <img v-show="this.dolbydetected" width="35px" :src="require('@/assets/logo/dolby_on.png')" />
            <img v-show="!this.dolbydetected" width="35px" :src="require('@/assets/logo/dolby.png')" />
          </v-btn>
          <v-btn class="pt-5 pl-0 ml-0 pr-0 mr-0" :disabled="true" :ripple="false" :stacked="false" density="compact" size="x-small"
            variant="plain">
            <v-img v-show="this.flacEnabled" width="18px" :src="require('@/assets/icons/flac_green.svg')"></v-img>
            <v-img v-show="!this.flacEnabled" width="18px" :src="require('@/assets/icons/flac.svg')"></v-img>
          </v-btn>
        </v-row>
        <v-row justify="center" class="mt-0">
          <v-col cols="1" align="end" class="pa-0 ma-0 mt-2 pr-2">
            <span class="track-info">{{ formatTime(currentTime) }}</span>
          </v-col>
          <v-col v-if="currentTrackInfo === 0" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#1ff050" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col v-if="currentTrackInfo === 1" cols="10" class="pa-0 ma-0 mt-1">
            <v-slider v-model="currentTime" :max="duration" step="1" color="#E34234" :thumb-size="10" thumb-color="white"
              track-color="grey" class="progress-bar" @start="this.stopupdate()" @end="this.seek()"></v-slider>
          </v-col>
          <v-col cols="1" class="pa-0 ma-0 mt-2 pl-2">
            <span class="track-info mt-3">{{ formatTime(duration) }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2" class="mt-0">
        <v-row justify="center" class="mt-1">
          <v-btn icon="mdi-playlist-music" class="open-tracks-btn pt-4 pa-0 ma-0 ml-0 pr-4 pl-4" :ripple="false"  :stacked="false" size="x-small" density="compact" variant="plain"
            style="color: white !important" @click="openTracklist">
          </v-btn>
          <v-expand-transition @after-enter="loadingdata = true">
            <v-card v-if="showTrackDropdown" v-click-outside="clickedOutsideTracks" class="playlist-card-tracks" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="trackSearchQuery" placeholder="Search in queue" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="tracks.length === 0" @click="this.shuffleTracks()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Shuffle everything..
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isTrackLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingdata">
                      <v-list v-show="!isTrackLoading" ref="tracksList" @scroll.passive="onScrollTracks" style="
                          max-height: 348px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="(track, index) in getVisibleTracks" :key="index">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="
                                          this.playOrPauseSongTracks(
                                            track,
                                            track.originalIndex
                                          )
                                          " :src="track.art" contain cover max-height="30px" max-width="30px"
                                          class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(track)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="track.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            track.id
                                            " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                                                                  <a v-if="
                                            track.type === 'podcast' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              track.id
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'podcast' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              track.album
                                              " class="artist-link ml-2">{{ track.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon :disabled="tracks.length === 1 ||
                                        (ismusicloading &&
                                          this.ifCurrentMusicNow(track) &&
                                          track.originalIndex ===
                                          currentTrackIndex &&
                                          this.queueremoval)
                                        " @click="
                                          this.queueremoval = true;
                                        this.removeFromQueue(
                                          track,
                                          track.originalIndex
                                        );
                                        " class="simple-icon" color="white">
                                        mdi-playlist-minus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-star" class="open-favs-btn pt-4 pa-0 ma-0 pl-4 pr-4" :ripple="false"  :stacked="false" size="x-small" density="compact" variant="plain"
            style="color: #f0e556 !important" @click="this.openFavs()">
          </v-btn>
          <v-expand-transition @after-enter="loadingfavs = true">
            <v-card v-if="showFavsDropdown" v-click-outside="clickedOutsideFavs" class="playlist-card-fav" style="
                position: fixed !important;
                right: 0;
                width: 300px !important;
                height: 430px !important;
              ">
              <v-card-text>
                <v-text-field v-model="favsSearchQuery" placeholder="Search in favourites" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="userFavSongs.length === 0" @click="this.addAllFavsToQueue()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Queue all..
                  </v-btn>
                  <v-btn :disabled="userFavSongs.length === 0 || ismusicloading" @click="this.addAllFavsToEmptyQueue()"
                    class="menu-btn-close2 mt-1" style="border-radius: 10px" elevation="0" height="36px">
                    Play all
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isFavsLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingfavs">
                      <v-list v-show="!isFavsLoading" ref="favsList" @scroll.passive="onScrollFavs" style="
                          max-height: 302px;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="fav in getVisibleFavs" :key="fav.id">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-0 ma-0">
                                  <v-col cols="10" class="pa-0 ma-0">
                                    <v-row justify="start" class="pa-0 ma-0">
                                      <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="this.playOrPauseSong(fav)" :src="fav.art" contain cover
                                          max-height="30px" max-width="30px" class="album-art2">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            !this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(fav)
                                          " class="overlay-icon" color="white" size="30px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(fav)
                                          " class="music-icon" color="#1ff050" size="30px">mdi-music</v-icon>
                                        </v-img>
                                      </v-col>
                                      <v-col cols="10" class="pa-0 ma-0 pt-1 pl-1">
                                        <div style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 180px;
                                          ">
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            fav.id
                                            " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                                                                  <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              fav.id
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              fav.album
                                              " class="artist-link ml-2">{{ fav.title }}</a>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-1">
                                    <span>
                                      <v-icon @click="this.addtoQueue(fav)" class="simple-icon" color="white">
                                        mdi-playlist-plus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-plus" class="open-search-btn pt-4 pa-0 ma-0 mr-0 pr-4 pl-4" :ripple="false"  :stacked="false" size="x-small" density="compact" variant="plain"
            style="color: #1ff050 !important" @click="this.openSearch()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="showSearchDropdown" v-click-outside="clickedOutsideSearch" class="playlist-card-search" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 83px) !important;
              ">
              <v-card-item>
                <MusicSearch/>
              </v-card-item>
            </v-card>
          </v-expand-transition>
        </v-row>
        <v-row justify="center" align="center" class="mt-10">
          <v-btn :icon="volume === 0 ? 'mdi-volume-mute' : 'mdi-volume-high'" :ripple="false" density="compact"
            size="small" variant="plain" style="color: white !important" @click="this.toggleMute()"
            class="mr-0 pr-0 pb-5">
          </v-btn>
          <v-slider v-model="volume" step="1" min="0" max="100" color="#1ff050" :thumb-size="10" thumb-color="white"
            track-color="grey" class="progeess-bar pr-8 pl-0 ml-0" @end="this.changeVolume()"></v-slider>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="isMobilePlayer1 && isMobilePlayer2 && isMobilePlayer3">
      <v-row class="pb-0 mb-0">
        <v-col @click="this.showMobilePlayer=!this.showMobilePlayer"  cols="7" style="cursor:pointer;" class="mt-0 pb-0 mb-0">
          <v-row>
              <v-img :src="currentTrack.art" contain cover max-height="42px" min-width="42px" max-width="42px" class="album-art ml-4 mt-5">
              </v-img> 
              <div class="track-info mt-3 ml-2">
                  <div class="track-title" style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      min-width: 155px;
                      max-width: 155px;
                    ">
                    <span class="artist-link" style="cursor:pointer">{{ currentTrack.title }}</span>              
                  </div>
                  <div style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      min-width: 155px;
                      max-width: 155px;
                    ">
                      <span v-if="currentTrack.nft_is === 1">
                          <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                          </span>
                          <span v-if="currentTrack.type === 'geo'" style="color: white">,
                          </span>
                        <span style="color: #f01ff0">NFT </span> by
                        <span class="artist-link" style="cursor:pointer">{{ currentTrack.creator }}&nbsp;</span>
                      </span>
                      <span v-else>
                          <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO&nbsp;
                          </span>
                      </span>

                      <span v-for="(artist, index) in currentTrack.artists" :key="index">
                        <span class="artist-link" style="cursor:pointer">{{ artist }}</span>
                        <span v-if="index < currentTrack.artists.length - 1">, </span>
                      </span>
                  </div>              
              </div>
          </v-row>
        </v-col>
        <v-expand-transition>
              <v-card v-if="showMobilePlayer" class="playlist-card-search-mobile" style="
                  position: fixed !important;
                  right: 0;
                  width: 100vw !important;
                  height: calc(100dvh - 124px) !important;
                ">
                <v-card-item height="100%">
                  <v-row>
                    <v-col cols="2">
                      <v-btn icon="mdi-chevron-down" class="pt-4 pa-0 ma-0 mr-0 pr-4 pl-0" :ripple="false"  size="large" density="compact" variant="plain"
                      style="color: white !important" @click="this.showMobilePlayer=false;">
                      </v-btn>
                    </v-col>
                    <v-col cols="7">
                      <div class="track-info pt-5 ml-2">
                        <div class="track-title" style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          min-width: 200px;
                          max-width: 200px;
                          ">
                          <span v-if="currentTrack.nft_is === 1">
                            <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                            </span>
                            <span v-if="currentTrack.type === 'geo'" style="color: white">,
                            </span>
                          <span style="color: #f01ff0">NFT </span> by
                          <span class="artist-link" style="cursor:pointer">{{ currentTrack.creator }}&nbsp;</span>
                          </span>
                          <span v-else>
                            <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO&nbsp;
                            </span>
                          </span>
                          <span class="artist-link" style="cursor:pointer">{{ currentTrack.title }}</span>              
                        </div>           
                      </div>
                    </v-col>
                    <v-col cols="3" justify="center">
                          <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(currentTrack.id)" icon="mdi-star-outline"
                            class="pt-7" :ripple="false" density="compact" size="small" variant="plain"
                            style="color: white !important" @click="this.addToFav(currentTrack)">
                          </v-btn>
                          <v-btn v-else icon="mdi-star" class="pt-7" :ripple="false" density="compact" size="small" variant="plain"
                            style="color: #f0e556 !important" @click="this.removeFromFav(currentTrack)">
                          </v-btn>
                    </v-col>
                  </v-row>
                </v-card-item>
                <v-card-text>
                    <v-row class="pt-3" justify="center">
                      <v-img :src="currentTrack.art" contain cover max-height="200px" min-width="200px" max-width="200px" class="album-art-mobile">
                      </v-img> 
                    </v-row>
                    <v-row class="pt-2 pl-6">
                                    <div class="track-info">
                                        <div class="track-title" style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 300px;
                                          ">
                                          <a v-if="
                                            currentTrack.type === 'muze' &&
                                            currentTrack.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              currentTrack.id
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="
                                            currentTrack.type === 'muze' &&
                                            currentTrack.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                            currentTrack.album
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="currentTrack.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            currentTrack.id
                                            " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="currentTrack.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            currentTrack.id
                                            " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="
                                            currentTrack.type === 'global' &&
                                            currentTrack.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                          currentTrack.id
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="
                                            currentTrack.type === 'global' &&
                                            currentTrack.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                          currentTrack.album
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                                                                  <a v-if="
                                            currentTrack.type === 'podcast' &&
                                            currentTrack.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                          currentTrack.id
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                          <a v-if="
                                            currentTrack.type === 'podcast' &&
                                            currentTrack.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                          currentTrack.album
                                              " class="artist-link">{{ currentTrack.title }}</a>
                                        </div>
                                        <div style="
                                                    white-space: nowrap;
                                                    overflow: hidden;
                                                    text-overflow: ellipsis;
                                                    max-width: 300px;
                                                  ">
                                          <span v-for="(artist, index) in currentTrack.artists" :key="index">
                                            <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                                              }}</a>
                                            <span v-if="index < currentTrack.artists.length - 1">, </span>
                                          </span>
                                        </div>
                                        <div v-if="currentTrack.nft_is === 1" style="
                                        white-space: nowrap;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        min-width: 300px;
                                        max-width: 300px;
                                          ">
                                          <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                                          </span>
                                          <span v-if="currentTrack.type === 'geo'" style="color: white">,
                                          </span>
                                          <span style="color: #f01ff0">NFT </span> by
                                          <a :href="'https://muze.muzible.com/creator/' + currentTrack.creator" class="artist-link">{{
                                            currentTrack.creator }}</a>
                                        </div>
                                        <div v-else style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            min-width: 300px;
                                            max-width: 300px;">
                                            <span v-if="currentTrack.type === 'geo'" style="color: #f0e556">GEO
                                            </span>
                                        </div>
                                    </div>
                    </v-row>
                    <v-row class="pt-1" justify="center">
                        <v-btn density="compact" class="pt-2" :ripple="false" icon="mdi-rewind-15" variant="plain" size="medium"
                          style="color: white !important" @click="this.rewind15()">
                        </v-btn>
                        <v-btn density="compact" class="pt-2" :ripple="false" :disabled="ismusicloading" icon="mdi-skip-previous"
                          variant="plain" size="large" style="color: white !important" @click="
                            this.$store.dispatch('setIsMusicLoading', true);
                          this.prevTrack();
                          ">
                        </v-btn>
                        <v-btn :icon="repeatModeIcon" class="pt-2 ma-0 pl-0 pr-0" :ripple="false" density="compact" size="large" variant="plain"
                          style="color: white !important" @click="this.toggleRepeat()">
                        </v-btn>
                        <v-btn icon="mdi-skip-next" class="pt-2" :ripple="false" :disabled="ismusicloading" density="compact"
                          size="large" variant="plain" style="color: white !important" @click="
                            this.$store.dispatch('setIsMusicLoading', true);
                          this.nextTrack();
                          ">
                        </v-btn>
                        <v-btn icon="mdi-fast-forward-15" class="pt-2" :ripple="false" density="compact" size="medium" variant="plain"
                          style="color: white !important" @click="this.fastForward15()">
                        </v-btn>
                    </v-row>
                    <v-row class="pt-1" justify="center">
                        <v-btn class="pt-2 pr-0 mr-0" :disabled="true" :ripple="false" density="compact" size="x-small" variant="plain">
                          <img v-show="this.dolbydetected" width="40px" :src="require('@/assets/logo/dolby_on.png')" />
                          <img v-show="!this.dolbydetected" width="40px" :src="require('@/assets/logo/dolby.png')" />
                        </v-btn>
                        <v-btn class="pt-2 pl-0 ml-0 pr-0 mr-0" :disabled="true" :ripple="false" density="compact" size="x-small"
                          variant="plain">
                          <v-img v-show="this.flacEnabled" width="20px" :src="require('@/assets/icons/flac_green.svg')"></v-img>
                          <v-img v-show="!this.flacEnabled" width="20px" :src="require('@/assets/icons/flac.svg')"></v-img>
                        </v-btn>
                        <v-btn v-show="!this.sorroundloaded" class="pt-1" :disabled="true" :ripple="false" density="compact"
                        size="small" variant="plain" style="color: white !important" icon="mdi-surround-sound-5-1">
                        </v-btn>
                        <v-btn v-show="this.sorroundloaded" class="pt-1" :disabled="true" :ripple="false" density="compact"
                          size="small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound-5-1">
                        </v-btn>
                        <v-btn v-show="!this.atmosdetected" class="pt-1" :disabled="true" :ripple="false" density="compact"
                          size="small" variant="plain" style="color: white !important" icon="mdi-surround-sound">
                        </v-btn>
                        <v-btn v-show="this.atmosdetected" class="pt-1" :disabled="true" :ripple="false" density="compact"
                          size="small" variant="plain" style="color: #1ff050 !important" icon="mdi-surround-sound">
                        </v-btn>
                    </v-row>
                    <v-row justify="center" align="center" class="pt-1">
                      <v-btn :icon="volume === 0 ? 'mdi-volume-mute' : 'mdi-volume-high'" :ripple="false" density="compact"
                        size="small" variant="plain" style="color: white !important" @click="this.toggleMute()"
                        class="mr-0 pr-0 pb-5">
                      </v-btn>
                      <v-slider v-model="volume" step="1" min="0" max="100" color="#1ff050" :thumb-size="10" thumb-color="white"
                        track-color="grey" class="progeess-bar pr-10 pl-0 ml-0" @end="this.changeVolume()"></v-slider>
                    </v-row>
                  </v-card-text>
              </v-card>
        </v-expand-transition>
        <v-col cols="5" class="mt-0 pr-8 pb-0 mb-0">
          <v-row justify="end" class="mt-0">
            <v-btn v-show="this.currentQuality === -1" icon="mdi-signal-cellular-outline" class="pt-5" :ripple="false" :stacked="false"
              density="compact" size="small" variant="plain" :disabled="true" style="color: grey !important">
            </v-btn>
            <v-btn v-show="this.currentQuality === 0" icon="mdi-signal-cellular-1" class="pt-5" :ripple="false" :stacked="false"
              density="compact" size="small" variant="plain" :disabled="true" style="color: #E34234 !important">
            </v-btn>
            <v-btn v-show="this.currentQuality === 1" icon="mdi-signal-cellular-2" class="pt-5" :ripple="false" :stacked="false"
              density="compact" size="small" variant="plain" :disabled="true" style="color: yellow !important">
            </v-btn>
            <v-btn v-show="this.currentQuality === 2" icon="mdi-signal-cellular-3" class="pt-5" :ripple="false" :stacked="false"
              density="compact" size="small" variant="plain" :disabled="true" style="color: green !important">
            </v-btn>
            <v-btn v-show="this.currentQuality === 3" icon="mdi-signal-cellular-3" class="pt-5" :ripple="false" :stacked="false"
              density="compact" size="small" variant="plain" :disabled="true" style="color: green !important">
            </v-btn>
            <v-btn v-if="isPlaying" :ripple="false" density="compact" icon="mdi-pause" variant="plain" size="large"
              style="color: white !important" @click="this.togglePlayPause()">
            </v-btn> 
            <v-btn v-if="!isPlaying" :ripple="false" density="compact" icon="mdi-play-circle" variant="plain" size="large"
              style="color: white !important" :disabled="usehls && hlsready === false && this.playHLScheck(this.currentTrack)
                " @click="this.togglePlayPause()">
            </v-btn>
            <v-expand-transition>
              <v-card v-if="currentTrackInfo === 1" class="playlist-card-noplay-mobile" style="
                  position: fixed !important;
                  width: 100vw !important;
                  height: 42px !important;
                  padding: 0px!important;
                  margin: 0px!important;
                ">
                <v-card-text v-if="user">
                  <v-row justify="center" class="pa-0 ma-0">
                    <span v-if="
                      currentTrack.type === 'geo'
                    " style="color: #f0e556">GEO</span>
                    <span v-if="
                      currentTrack.nft_is === 1 && currentTrack.type === 'geo'
                    " style="color: #f01ff0">&nbsp;NFT</span>
                    <span v-if="
                      currentTrack.nft_is === 1 && currentTrack.type !== 'geo'
                    " style="color: #f01ff0">NFT</span>
                    <span v-if="currentTrack.stream_lvl > user.level" style="color: #e34234">
                      &nbsp;Plan upgrade required or creator subscription</span>
                    <span v-if="this.geoOwnerOnly" style="color: #e34234">&nbsp; Music in location restricted to NFT owners</span>
                  </v-row>
                  <v-row justify="center" class="pa-0 ma-0">
                    <span v-if="this.geoPassed" style="color: #e34234">Music not available anymore in this location</span>
                    <span v-else style="color: #e34234">Not allowed to play full track, only preview available</span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>
            <v-expand-transition>
              <v-card v-if="this.hlsProblem" class="playlist-card-noplay-mobile" style="
                  position: fixed !important;
                  width: 100vw !important;
                  height: 22px !important;
                  padding: 0px!important;
                  margin: 0px!important;
                ">
                <v-card-text v-if="user">
                  <v-row justify="center" class="pa-0 ma-0">
                    <span style="color: #e34234">Stream error, downgraded to lower quality..</span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>
          </v-row>
        </v-col>
      </v-row>
      <div justify="center" class="ma-0 pa-0" >
            <span style="z-index: 11; color: white; font-size: 13px; position: fixed; bottom: 40px; left:8px;">{{ formatTime(currentTime) }}</span>
            <v-slider v-if="currentTrackInfo === 0"  style="z-index: 12;" v-model="currentTime" :max="duration" step="1" color="#1ff050" :thumb-size="6" thumb-color="white"
              track-color="grey" class="progress-bar-mobile" @start="this.stopupdate()" @end="this.seek()"></v-slider>
            <v-slider v-if="currentTrackInfo === 1"  style="z-index: 12;" v-model="currentTime" :max="duration" step="1" color="#E34234" :thumb-size="6" thumb-color="white"
              track-color="grey" class="progress-bar-mobile" @start="this.stopupdate()" @end="this.seek()"></v-slider>
            <span style="z-index: 11; color: white; font-size: 13px; position: fixed; bottom: 40px; right:8px;">{{ formatTime(duration) }}</span>
      </div>
      <v-row justify="center" class="mt-0 pa-0 ma-0">
          <v-btn v-if="this.notinPlaylists(currentTrack.id)" icon="mdi-plus-circle-outline" class="open-playlist-btn pt-0 pl-0 ma-0 pa-0"  
            :ripple="false" density="compact" size="large" variant="plain" style="color: white !important"
            @click="this.openAddPlaylist(currentTrack)">
          </v-btn>
          <v-btn v-else icon="mdi-plus-circle" class="open-playlist-btn pt-0 pl-0 ma-0 pa-0" :ripple="false" density="compact" size="large" 
             variant="plain" style="color: #1ff050 !important" @click="this.openAddPlaylist(currentTrack)">
          </v-btn>          
          <v-expand-transition @after-enter="loadingplaylist = true">
                  <v-card v-if="showPlaylistDropdown" v-click-outside="clickedOutsidePlaylist" class="playlist-card-pl-mobile"
                    style="
                    position: fixed !important;
                    width: 100vw !important;
                    height: calc(100dvh - 124px) !important;
                  ">
                    <v-card-text>
                      <v-text-field v-model="playlistSearchQuery" placeholder="Search in playlists" density="compact"
                        hide-details clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                        bg-color="black"></v-text-field>
                      <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                        <v-btn @click="this.createNewPlaylist(currentTrack)"
                          :disabled="userPlaylists.length > 99 || playlistcreation" class="menu-btn-close2"
                          style="border-radius: 10px" elevation="0" height="36px">
                          New playlist..
                        </v-btn>
                      </v-row>
                      <div>
                        <Transition name="fade2">
                          <div v-show="isPlaylistLoading" class="loading-spinner">
                            <v-progress-circular indeterminate color="white"></v-progress-circular>
                          </div>
                        </Transition>
                        <Transition name="fade2">
                          <div v-if="loadingplaylist">
                            <v-list v-show="!isPlaylistLoading" ref="playlistList" @scroll.passive="onScrollMobile" style="
                              max-height: calc(100dvh - 200px)!important;
                              overflow-y: scroll;
                              background-color: black;
                              color: white;
                            ">
                              <v-list-item v-for="playlist in getVisiblePlaylistsMobile" :key="playlist.id"
                                style="cursor: pointer" @click="this.toggleTrackInPlaylist(playlist)">
                                <v-hover>
                                  <template v-slot:default="{ isHovering, props }">
                                    <div v-bind="props" class="pa-0 ma-0">
                                      <v-row v-if="playlist.tracks.length < 150" class="pa-2 ma-0">
                                        <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="60px" max-width="60px"
                                                class="album-art-row">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="60px">mdi-playlist-play</v-icon>
                                              </v-img>
                                        </v-col>
                                        <v-col cols="8" class="pa-0 ma-0 pl-4 pt-4">
                                            <div class="track-info">
                                              <div class="track-title" style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 200px;
                                              ">
                                                <span class="artist-link">{{ playlist.name }}</span>
                                              </div>
                                            </div>  
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-4">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050" size="large">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white" size="large">
                                              mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                      <v-row v-if="playlist.tracks.length >= 150" class="pa-2 ma-0">
                                        <v-col cols="2" class="pa-0 ma-0">
                                              <v-img @click.stop="
                                                this.addFullTracksToPlay(playlist)
                                                " :src="playlist.src" contain cover max-height="60px" max-width="60px"
                                                class="album-art-row">
                                                <v-icon v-if="isHovering" class="overlay-icon" color="white"
                                                  size="60px">mdi-playlist-play</v-icon>
                                              </v-img>
                                        </v-col>
                                        <v-col cols="8" class="pa-0 ma-0 pl-4">
                                            <div class="track-info">
                                              <div class="track-title" v-show="!isHovering ||
                                                playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 200px;
                                              ">
                                                <span class="artist-link">{{ playlist.name }}</span>
                                              </div>
                                              <div v-show="isHovering &&
                                                !playlist.tracks.includes(
                                                  currentTrackToAdd.id
                                                )
                                                " style="overflow: hidden" class="overlay-pl-mobile pa-0 ma-0 ml-4 mt-4">
                                                <span class="overlay-text-pl pa-0">Playlist Full</span>
                                              </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="2" align="end" class="pa-0 ma-0 pt-4">
                                          <span>
                                            <v-icon v-if="
                                              playlist.tracks.includes(
                                                currentTrackToAdd.id
                                              )
                                            " color="#1ff050" size="large">
                                              mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else color="white" size="large">
                                              mdi-close-circle-outline
                                            </v-icon>
                                          </span>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-hover>
                              </v-list-item>
                            </v-list>
                          </div>
                        </Transition>
                      </div>
                    </v-card-text>
                  </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-music" class="open-tracks-btn pt-0 pa-0 ma-0 ml-0" :ripple="false" density="compact" size="large" variant="plain"
            style="color: white !important" @click="openTracklist">
          </v-btn>
          <v-expand-transition @after-enter="loadingdata = true">
            <v-card v-if="showTrackDropdown" v-click-outside="clickedOutsideTracks" class="playlist-card-tracks-mobile" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 124px) !important;
              ">
              <v-card-text>
                <v-text-field v-model="trackSearchQuery" placeholder="Search in queue" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="tracks.length === 0" @click="this.shuffleTracks()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Shuffle everything..
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isTrackLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingdata">
                      <v-list v-show="!isTrackLoading" ref="tracksList" @scroll.passive="onScrollTracksMobile" style="
                          max-height: calc(100dvh - 200px)!important;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="(track, index) in getVisibleTracksMobile" :key="index">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-2 ma-0">
                                  <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="
                                          this.playOrPauseSongTracks(
                                            track,
                                            track.originalIndex
                                          )
                                          " :src="track.art" contain cover max-height="60px" max-width="60px"
                                          class="album-art-row">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(track)
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(track) &&
                                            !this.isPlayingNow(track) &&
                                            track.originalIndex !==
                                            currentTrackIndex
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(track) &&
                                            track.originalIndex ===
                                            currentTrackIndex
                                          " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>
                                        </v-img>
                                  </v-col>
                                  <v-col cols="8" class="pa-0 ma-0 pl-4">
                                      <div class="track-info">
                                        <div class="track-title" style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 200px;
                                          ">
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'muze' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link">{{ track.title }}</a>
                                          <a v-if="track.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            track.id
                                            " class="artist-link">{{ track.title }}</a>
                                          <a v-if="track.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            track.id
                                            " class="artist-link">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              track.id
                                              " class="artist-link">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'global' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              track.album
                                              " class="artist-link">{{ track.title }}</a>
                                                                                  <a v-if="
                                            track.type === 'podcast' &&
                                            track.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              track.id
                                              " class="artist-link">{{ track.title }}</a>
                                          <a v-if="
                                            track.type === 'podcast' &&
                                            track.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              track.album
                                              " class="artist-link">{{ track.title }}</a>
                                        </div>
                                        <div style="
                                                    white-space: nowrap;
                                                    overflow: hidden;
                                                    text-overflow: ellipsis;
                                                    max-width: 200px;
                                                  ">
                                          <span v-for="(artist, index) in track.artists" :key="index">
                                            <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                                              }}</a>
                                            <span v-if="index < track.artists.length - 1">, </span>
                                          </span>
                                        </div>
                                      </div>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-4">
                                    <span>
                                      <v-icon :disabled="tracks.length === 1 ||
                                        (ismusicloading &&
                                          this.ifCurrentMusicNow(track) &&
                                          track.originalIndex ===
                                          currentTrackIndex &&
                                          this.queueremoval)
                                        " @click="
                                          this.queueremoval = true;
                                        this.removeFromQueue(
                                          track,
                                          track.originalIndex
                                        );
                                        " class="simple-icon" color="white" size="large">
                                        mdi-playlist-minus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-star" class="open-favs-btn pt-0 pa-0 ma-0" :ripple="false" density="compact" size="large" variant="plain"
            style="color: #f0e556 !important" @click="this.openFavs()">
          </v-btn>
          <v-expand-transition @after-enter="loadingfavs = true">
            <v-card v-if="showFavsDropdown" v-click-outside="clickedOutsideFavs" class="playlist-card-fav-mobile" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 124px) !important;
              ">
              <v-card-text>
                <v-text-field v-model="favsSearchQuery" placeholder="Search in favourites" density="compact" hide-details
                  clearable class="custom-placeholder-color" color="#ffffff" base-color="white"
                  bg-color="black"></v-text-field>
                <v-row style="cursor: pointer" justify="start" class="pa-0 ma-1">
                  <v-btn :disabled="userFavSongs.length === 0" @click="this.addAllFavsToQueue()" class="menu-btn-close2"
                    style="border-radius: 10px" elevation="0" height="36px">
                    Queue all..
                  </v-btn>
                  <v-btn :disabled="userFavSongs.length === 0 || ismusicloading" @click="this.addAllFavsToEmptyQueue()"
                    class="menu-btn-close2 mt-1" style="border-radius: 10px" elevation="0" height="36px">
                    Play all
                  </v-btn>
                </v-row>
                <div>
                  <Transition name="fade2">
                    <div v-show="isFavsLoading" class="loading-spinner">
                      <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                  </Transition>
                  <Transition name="fade2">
                    <div v-if="loadingfavs">
                      <v-list v-show="!isFavsLoading" ref="favsList" @scroll.passive="onScrollFavsMobile" style="
                          max-height: calc(100dvh - 236px)!important;
                          overflow-y: scroll;
                          background-color: black;
                          color: white;
                        ">
                        <v-list-item v-for="fav in getVisibleFavsMobile" :key="fav.id">
                          <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                              <div v-bind="props" class="pa-0 ma-0">
                                <v-row class="pa-2 ma-0">
                                  <v-col cols="2" class="pa-0 ma-0">
                                        <v-img @click="this.playOrPauseSong(fav)" :src="fav.art" contain cover
                                          max-height="60px" max-width="60px" class="album-art-row">
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            this.ifCurrentMusicNow(fav) &&
                                            !this.isPlayingNow(fav)
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            isHovering &&
                                            !this.ifCurrentMusicNow(fav)
                                          " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                                          <v-icon v-if="
                                            !isHovering &&
                                            this.isPlayingNow(fav)
                                          " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>
                                        </v-img>
                                  </v-col>
                                  <v-col cols="8" class="pa-0 ma-0 pl-4">
                                      <div class="track-info">
                                        <div class="track-title" style="
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 200px;
                                          ">
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'muze' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' +
                                            fav.id
                                            " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="fav.type === 'geo'" :href="'https://verse.muzible.com/track/' +
                                            fav.id
                                            " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/track/' +
                                              fav.id
                                              " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'global' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/album/' +
                                              fav.album
                                              " class="artist-link">{{ fav.title }}</a>
                                                                                  <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album === ''
                                          " :href="'https://muze.muzible.com/episode/' +
                                              fav.id
                                              " class="artist-link">{{ fav.title }}</a>
                                          <a v-if="
                                            fav.type === 'podcast' &&
                                            fav.album !== ''
                                          " :href="'https://muze.muzible.com/podcast/' +
                                              fav.album
                                              " class="artist-link">{{ fav.title }}</a>
                                        </div>
                                        <div style="
                                                    white-space: nowrap;
                                                    overflow: hidden;
                                                    text-overflow: ellipsis;
                                                    max-width: 200px;
                                                  ">
                                          <span v-for="(artist, index) in fav.artists" :key="index">
                                            <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                                              }}</a>
                                            <span v-if="index < fav.artists.length - 1">, </span>
                                          </span>
                                        </div>
                                      </div>
                                  </v-col>
                                  <v-col cols="2" align="end" class="pa-0 ma-0 pt-4">
                                    <span>
                                      <v-icon @click="this.addtoQueue(fav)" class="simple-icon" color="white" size="large">
                                        mdi-playlist-plus
                                      </v-icon>
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-hover>
                        </v-list-item>
                      </v-list>
                    </div>
                  </Transition>
                </div>
              </v-card-text>
            </v-card>
          </v-expand-transition>
          <v-btn icon="mdi-playlist-plus" class="open-search-btn pt-0 pa-0 ma-0 mr-0" :ripple="false" density="compact" size="large" variant="plain"
            style="color: #1ff050 !important" @click="this.openSearch()">
          </v-btn>
          <v-expand-transition>
            <v-card v-if="showSearchDropdown" v-click-outside="clickedOutsideSearch" class="playlist-card-search-mobile" style="
                position: fixed !important;
                right: 0;
                width: 100vw !important;
                height: calc(100dvh - 124px) !important;
              ">
              <v-card-item>
                <MusicSearch/>
              </v-card-item>
            </v-card>
          </v-expand-transition>
      </v-row>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { nextTick } from "vue";
import shaka from "shaka-player";
import MusicSearch from "@/components/MusicSearch.vue";
import { useMobilePlayer1 } from "@/composables/useMobilePlayer1.js";
import { useMobilePlayer2 } from "@/composables/useMobilePlayer2.js";
import { useMobilePlayer3 } from "@/composables/useMobilePlayer3.js";

// For full logging
//import shaka from 'shaka-player/dist/shaka-player.ui.debug';

// INFO: przepisac 1:1 w komponentach ($getters access): currentTrack, notinFav(id), notinPlaylists(id), playHLScheck(track), isPlayingNow(fav), ifCurrentMusicNow(fav),
// INFO: eventy dostepne dla innych komponentow 1: addAllFavsToEmptyQueue(), addtoQueue(track), addAllFavsToQueue(), removeFromFav(track), addToFav(track), addFullTracksToPlay(playlist), addFullCreatorToQueue(creator.id)
// INFO: eventy dostepne dla innych komponentow 2: playOrPauseSong(track),toggleTrackInPlaylistExt(playlist, track), createNewPlaylist(track), shuffleTracks(), addFullAlbumToPlay(album), addFullArtistToQueue(artist.id)

// TODO: Przygotowanie produkcyjnych playlist, utworow itd. zaladowanie ich na amazona do streamu bez royalty, darmowe libki
// TODO: Mobile version,

export default {
  setup() {
    const isMobilePlayer1 = useMobilePlayer1();
    const isMobilePlayer2 = useMobilePlayer2();
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };
    return { notify, notifyError, isMobilePlayer1, isMobilePlayer2, isMobilePlayer3 };
  },
  components: {
    MusicSearch,
  },
  data() {
    return {
      currentTime: 0,
      duration: 0,
      volume: 70,
      previousVolume: 70,
      seeking: false,
      repeatMode: "all",
      itemsPerPage: 7,
      itemsPerPageMobile: 10,
      itemsPerPageFavs: 6,
      itemsPerPageFavsMobile: 10,

      visibleTracks: [],
      visibleFavs: [],
      visiblePlaylists: [],

      currentTrackToAdd: null,
      showPlaylistDropdown: false,
      showFavsDropdown: false,
      showTrackDropdown: false,
      showSearchDropdown: false,
      showMobilePlayer: false,
      playlistSearchQuery: "",
      favsSearchQuery: "",
      trackSearchQuery: "",
      queueremoval: false,
      loadingdata: false,
      loadingfavs: false,
      loadingplaylist: false,
      isTrackLoading: true,
      isPlaylistLoading: true,
      isFavsLoading: true,
      previewWatching: false,
      hlsProblem: false,
      geoPassed: false,
      geoOwnerOnly: false,

      audio: new Audio(),
      hls: null,

      flacEnabled: false, // Flac or Alac
      sorroundloaded: false, // 5+ Channels
      atmosdetected: false, // Atmos or other Spatial Audio
      dolbydetected: false, // Dolby Digital codec

      currentQuality: 3, // 3 - brak streamingu, 0 - min, 1 - medium, 2 - max, -1 nie zaladowalo jeszcze
      actualminTrack: null,
      actualmaxTrack: null,
      location: null,

      justOpened: false, 
      justOpenedFavs: false,
      justOpenedTracks: false,
      justOpenedSearch: false,

      isMobileDevice: false, 

    };
  },
  computed: {
    // Player
    currentTrackIndex() {
      return this.$store.getters.getCurrentTrackIndex;
    },
    playlistcreation() {
      return this.$store.getters.getPlaylistCreation;
    },
    isPlaying() {
      return this.$store.getters.getIsPlaying;
    },
    ismusicloading() {
      return this.$store.getters.getIsMusicLoading;
    },
    currentTrackInfo() {
      return this.$store.getters.getCurrentTrackInfo;
    },
    usehls() {
      return this.$store.getters.getUseHls;
    },
    hlsready() {
      return this.$store.getters.getHlsReady;
    },
    user() {
      return this.$store.getters.getUserData;
    },
    userPlaylists() {
      return this.$store.getters.getUserPlaylists;
    },
    userExtPlaylists() {
      return this.$store.getters.getUserExtPlaylists;
    },
    userFavSongs() {
      return this.$store.getters.getUserFavSongs;
    },
    userSubscribedCreators() {
      return this.$store.getters.getUserSubscribedCreators;
    },
    tracks() {
      return this.$store.getters.getUserCurrentSongs;
    },

    // End Player

    currentTrack() {
      if (this.tracks.length === 0) {
        return this.$store.getters.getDefaultCurrentSong[0];
      }
      return this.tracks[this.currentTrackIndex];
    },
    repeatModeIcon() {
      if (this.repeatMode === "none") {
        return "mdi-repeat-off";
      } else if (this.repeatMode === "one") {
        return "mdi-repeat-once";
      } else {
        return "mdi-repeat";
      }
    },
    getVisiblePlaylists() {
      const filtered = this.filterPlaylists();
      if (
        filtered.length > this.visiblePlaylists.length &&
        this.visiblePlaylists.length < this.itemsPerPage
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visiblePlaylists.length);
      }
    },
    getVisiblePlaylistsMobile() {
      const filtered = this.filterPlaylists();
      if (
        filtered.length > this.visiblePlaylists.length &&
        this.visiblePlaylists.length < this.itemsPerPageMobile
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visiblePlaylists.length);
      }
    },
    getVisibleFavs() {
      const filtered = this.filterFavs();
      if (
        filtered.length > this.visibleFavs.length &&
        this.visibleFavs.length < this.itemsPerPageFavs
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visibleFavs.length);
      }
    },
    getVisibleFavsMobile() {
      const filtered = this.filterFavs();
      if (
        filtered.length > this.visibleFavs.length &&
        this.visibleFavs.length < this.itemsPerPageFavsMobile
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visibleFavs.length);
      }
    },
    getVisibleTracks() {
      const filtered = this.filterTracks();
      if (
        filtered.length > this.visibleTracks.length &&
        this.visibleTracks.length < this.itemsPerPage
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visibleTracks.length);
      }
    },
    getVisibleTracksMobile() {
      const filtered = this.filterTracks();
      if (
        filtered.length > this.visibleTracks.length &&
        this.visibleTracks.length < this.itemsPerPageMobile
      ) {
        return filtered.slice(0, filtered.length);
      } else {
        return filtered.slice(0, this.visibleTracks.length);
      }
    }
  },
  methods: {
    checkMaxBitrateForActiveCodec(activeTrack, variantTracks) {
      if (activeTrack) {
        // Filtruj ścieżki z tym samym kodekiem, co aktywna
        const sameCodecTracks = variantTracks.filter(
          (track) => track.codecs === activeTrack.codecs
        );

        // Posortuj ścieżki według bitrate rosnąco
        const sortedTracks = sameCodecTracks.sort(
          (a, b) => a.bandwidth - b.bandwidth
        );

        // Podziel na min, medium i max
        this.actualminTrack = sortedTracks[0];
        this.actualmaxTrack = sortedTracks[sortedTracks.length - 1];
        const length = sortedTracks.length;
        const third = Math.floor(length / 3);
        const twoThirds = third * 2;

        if (activeTrack.bandwidth <= sortedTracks[third - 1].bandwidth) {
          this.currentQuality = 0; // Low quality
        } else if (activeTrack.bandwidth <= sortedTracks[twoThirds - 1].bandwidth) {
          this.currentQuality = 1; // Medium quality
        } else {
          this.currentQuality = 2; // High quality
        }
      } else {
        this.currentQuality = -1;
      }
    },

    async loadhlssourceandplay(newsrc) {
      await this.hls.attach(this.audio);
      this.$store.dispatch("setHlsReady", false);
      this.flacEnabled = false;
      this.dolbydetected = false;
      this.sorroundloaded = false;
      this.atmosdetected = false;
      this.currentQuality = -1;
      this.hls
        .load(newsrc)
        .then(() => {
          // Pobierz dostępne poziomy jakości
          const tracks = this.hls.getVariantTracks();
          // Wybierz początkowy poziom
          const startTrack = tracks.find((track) => track.active);

          if (startTrack) {
            this.checkMaxBitrateForActiveCodec(startTrack, tracks);

            if (startTrack.channelsCount > 3) {
              this.sorroundloaded = true;
            } else {
              this.sorroundloaded = false;
            }

            if (startTrack.spatialAudio) {
              this.atmosdetected = true;
            } else {
              this.atmosdetected = false;
            }

            const currentCodec = startTrack.audioCodec;
            if (currentCodec.includes("flac")) {
              this.flacEnabled = true;
            } else if (currentCodec.includes("alac")) {
              this.flacEnabled = true;
            } else {
              this.flacEnabled = false;
              if (
                currentCodec.includes("ec-3") ||
                currentCodec.includes("ac-3")
              ) {
                this.dolbydetected = true;
              } else {
                this.dolbydetected = false;
              }
            }
          } else {
            this.currentQuality = 3;
            this.flacEnabled = false;
            this.sorroundloaded = false;
            this.atmosdetected = false;
            this.dolbydetected = false;
          }

          this.$store.dispatch("setHlsReady", true);
          this.audio.play();
          this.$store.dispatch("setIsPlaying", true);
        })
        .catch((error) => {
          this.$store.dispatch("setHlsReady", false);
          this.notifyError(
            "Stream error.. Network problem or stream not available"
          );
        });
    },
    async loadhlssource(newsrc) {
      await this.hls.attach(this.audio);
      this.$store.dispatch("setHlsReady", false);
      this.$store.dispatch("setIsPlaying", false);
      this.flacEnabled = false;
      this.dolbydetected = false;
      this.sorroundloaded = false;
      this.atmosdetected = false;
      this.currentQuality = -1;
      this.hls
        .load(newsrc)
        .then(() => {
          // Pobierz dostępne poziomy jakości
          const tracks = this.hls.getVariantTracks();
          // Wybierz początkowy poziom
          const startTrack = tracks.find((track) => track.active);

          if (startTrack) {
            this.checkMaxBitrateForActiveCodec(startTrack, tracks);
            if (startTrack.channelsCount > 3) {
              this.sorroundloaded = true;
            } else {
              this.sorroundloaded = false;
            }

            if (startTrack.spatialAudio) {
              this.atmosdetected = true;
            } else {
              this.atmosdetected = false;
            }

            const currentCodec = startTrack.audioCodec;
            if (currentCodec.includes("flac")) {
              this.flacEnabled = true;
            } else if (currentCodec.includes("alac")) {
              this.flacEnabled = true;
            } else {
              this.flacEnabled = false;
              if (
                currentCodec.includes("ec-3") ||
                currentCodec.includes("ac-3")
              ) {
                this.dolbydetected = true;
              } else {
                this.dolbydetected = false;
              }
            }
          } else {
            if (this.previewWatching) {
              this.currentQuality = -1;
            }
            this.flacEnabled = false;
            this.dolbydetected = false;
            this.sorroundloaded = false;
            this.atmosdetected = false;
          }

          this.$store.dispatch("setHlsReady", true);
          this.$store.dispatch("setIsPlaying", false);
        })
        .catch((error) => {
          this.$store.dispatch("setHlsReady", false);
          this.notifyError(
            "Stream error.. Network problem or stream not available"
          );
        });
    },

    async switchToNativeAudioOnly(src) {
      if (this.hls) {
        await this.hls.detach(); // Odłącz od elementu audio
      }
      this.sorroundloaded = false;
      this.flacEnabled = false;
      this.atmosdetected = false;
      this.dolbydetected = false;
      this.currentQuality = 3;
      this.audio.src = src;
      this.audio.load();
    },
    async switchToNativeAudioAndPlay(src) {
      if (this.hls) {
        await this.hls.detach(); // Odłącz od elementu audio
      }
      this.sorroundloaded = false;
      this.flacEnabled = false;
      this.atmosdetected = false;
      this.dolbydetected = false;
      this.currentQuality = 3;
      this.audio.src = src;
      this.audio.load();
      this.audio.play();
    },

    async initializeHLS() {
      shaka.polyfill.installAll();

      if (shaka.Player.isBrowserSupported()) {
        
        //For Full logging
        //shaka.log.setLevel(shaka.log.Level.V2);

        this.hls = new shaka.Player();

        this.hls.getNetworkingEngine().registerRequestFilter((type, request) => {
          if (type === shaka.net.NetworkingEngine.RequestType.SEGMENT || 
              type === shaka.net.NetworkingEngine.RequestType.MANIFEST ||
              type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
            request.allowCrossSiteCredentials = true;
          }
        });

        this.hls.configure("abr.enabled", true);
        this.hls.configure("abr.switchInterval", 6);
        this.hls.configure("streaming.autoLowLatencyMode", true);
        

        this.hls.configure("preferredAudioCodecs", [
          "flac",
          "alac",
          "ec-3",
          "ac-3",
          "mp4a.40.2",
        ]);

        // To log the configuration
        //console.log(this.hls.getConfiguration());

        // Konfiguracja DRM z uzyciem szyfrowania CENC pliku (Widevine, PlayReady, FairPlay) oraz konfiguracji w .mpd dla kazdego systemu DRM
        /*this.hls.configure({
                drm: {
                  servers: {
                    'com.widevine.alpha': 'https://widevine-license-server.example.com',
                    'com.microsoft.playready': 'https://playready-license-server.example.com',
                    'com.apple.fps.1_0': 'https://fairplay-license-server.example.com',
                  },
                  advanced: {
                    'com.apple.fps.1_0': {
                      serverCertificateUri: 'https://fairplay-server.example.com/certificate',
                      allowPersistedState: true // Umożliwia pamięć podręczną licencji w FairPlay
                    },
                    'com.widevine.alpha': {
                      allowPersistedState: true // Widevine pozwala na zapisanie licencji
                    },
                    'com.microsoft.playready': {
                      allowPersistedState: true // PlayReady z pamięcią licencji
                    }
                  }
                }
          });*/

        this.$store.dispatch("setHlsReady", false);
        this.$store.dispatch("setUseHls", true);

        // Obsługa zmiany poziomu jakości
        this.hls.addEventListener("adaptation", () => {
          const tracks = this.hls.getVariantTracks();
          const activeTrack = tracks.find((track) => track.active);

          if (activeTrack) {
            this.checkMaxBitrateForActiveCodec(activeTrack, tracks);
            if (activeTrack.channelsCount > 3) {
              this.sorroundloaded = true;
            } else {
              this.sorroundloaded = false;
            }

            if (activeTrack.spatialAudio) {
              this.atmosdetected = true;
            } else {
              this.atmosdetected = false;
            }

            const currentCodec = activeTrack.audioCodec;
            if (currentCodec.includes("flac")) {
              this.flacEnabled = true;
            } else if (currentCodec.includes("alac")) {
              this.flacEnabled = true;
            } else {
              this.flacEnabled = false;
              if (
                currentCodec.includes("ec-3") ||
                currentCodec.includes("ac-3")
              ) {
                this.dolbydetected = true;
              } else {
                this.dolbydetected = false;
              }
            }
          } else {
            this.currentQuality = -1;
            this.flacEnabled = false;
            this.atmosdetected = false;
            this.sorroundloaded = false;
            this.dolbydetected = false;
          }
        });

        // Obsługa zmiany adaptaion set/kodeka
        this.hls.addEventListener("trackschanged", () => {
          const tracks = this.hls.getVariantTracks();
          const activeTrack = tracks.find((track) => track.active);

          if (activeTrack) {
            this.checkMaxBitrateForActiveCodec(activeTrack, tracks);
            if (activeTrack.channelsCount > 3) {
              this.sorroundloaded = true;
            } else {
              this.sorroundloaded = false;
            }

            if (activeTrack.spatialAudio) {
              this.atmosdetected = true;
            } else {
              this.atmosdetected = false;
            }

            const currentCodec = activeTrack.audioCodec;
            if (currentCodec.includes("flac")) {
              this.flacEnabled = true;
            } else if (currentCodec.includes("alac")) {
              this.flacEnabled = true;
            } else {
              this.flacEnabled = false;
              if (
                currentCodec.includes("ec-3") ||
                currentCodec.includes("ac-3")
              ) {
                this.dolbydetected = true;
              } else {
                this.dolbydetected = false;
              }
            }
          } else {
            this.currentQuality = -1;
            this.flacEnabled = false;
            this.atmosdetected = false;
            this.sorroundloaded = false;
            this.dolbydetected = false;
          }
        });

        // Obsługa błędów
        this.hls.addEventListener("error", (event) => {
          const error = event.detail;
          const currentManifestUrl = this.hls.getAssetUri();
          if (error) {
            if (error.severity === shaka.util.Error.Severity.RECOVERABLE) {
              switch (error.category) {
                case shaka.util.Error.Category.NETWORK:
                  this.hls.retryStreaming();
                  break;

                case shaka.util.Error.Category.MEDIA:
                  this.hls
                    .unload()
                    .then(() => {
                      return this.hls.load(currentManifestUrl);
                    })
                    .catch((unloadError) => {
                      this.notifyError(
                        "Stream media error.. Network problem or stream not available"
                      );
                    });
                  break;

                default:
                  this.notifyError(
                    "Stream recoverable error.. Network problem or stream not available"
                  );
                  break;
              }
            } else if (error.severity === shaka.util.Error.Severity.CRITICAL) {

              switch (error.category) {
                case shaka.util.Error.Category.MEDIA:
                  this.hls
                    .destroy()
                    .then(() => {
                      this.$store.dispatch("logErrorMedia", {
                        token: this.user.token,
                        trackid: this.currentTrack.id,
                        err: error,
                      });
                      this.notifyError(
                        "Stream error.. Not supported or wrong file! Try another browser or skip to next track! We logged this error."
                      );
                      this.$store.dispatch("setHlsReady", false);
                      this.$store.dispatch("setIsPlaying", false);
                      this.initializeHLS();
                    })
                    .catch((destroyError) => {
                      this.notifyError(
                        "Stream error.. Please refresh the browser"
                      );
                    });
                  break;

                default:
                  this.hls
                    .destroy()
                    .then(() => {
                      this.notifyError(
                        "Stream error defaulted.. Network problem or stream not available"
                      );
                      this.$store.dispatch("setHlsReady", false);
                      this.$store.dispatch("setIsPlaying", false);
                      this.initializeHLS();
                      this.loadTrackstart();
                    })
                    .catch((destroyError) => {
                      this.notifyError(
                        "Stream error.. Please refresh the browser"
                      );
                    });
                  break;
              }
            }
          }
        });

        await this.hls.attach(this.audio);
      } else {
        this.notifyError(
          "Stream error.. Browser not supported, please update or use different browser"
        );
        this.$store.dispatch("setUseHls", false);
        this.$store.dispatch("setHlsReady", false);
      }
    },
    playHLScheck(track) {
      // PRZEPISAC tam gdzie trzeba
      if (track.hlssrc !== "") {
        return true;
      } else {
        return false;
      }
    },
    onEnded() {
      if (!this.previewWatching) {
        this.$store.dispatch("logTrackerEnd", {
          token: this.user.token,
          trackid: this.currentTrack.id,
        });
      }
    },
    onPlay() {
      if (!this.previewWatching) {
        this.$store.dispatch("logTrackerStart", {
          token: this.user.token,
          trackid: this.currentTrack.id,
        });
      }
    },
    onPauseOrStop() {
      if (!this.previewWatching) {
        this.$store.dispatch("logTrackerPause", {
          token: this.user.token,
          trackid: this.currentTrack.id,
        });
      }
    },
    createNewPlaylist(currentTrack) {
      if (currentTrack.playable === 1){
      // EMITOWANE DLA PLAYERA
      const newplaylist = {
        name: currentTrack.title,
        saved: 0,
        liked: 0,
        public: 0, // jesli playlista jest public:1 to jest widoczna dla wszystkich, kazdy kto ja zapisze ma referencje do oryginalu, orygnal trzyma te informacje i jesli zmieni na public:0 to nie jest juz widoczna dla innych
        // ponadto jesli zostanie usunieta badz zmieniona na public, wszystkie rferencje musza zostac usuniete
        timestamp: "",
        creator: this.user.creator, // to move playlist from private to public you have to create unique creator id
        owner: this.user.email,
        id: "temporaryID",
        src: currentTrack.art,
        tracks: [currentTrack.id],
      };
      if (this.userPlaylists.length >= 100) {
        return;
      }
      this.$store.dispatch("setPlaylistCreation", true);
      this.$store
        .dispatch("createNewPlaylist", {
          token: this.user.token,
          playlist: newplaylist,
        })
        .then((response) => {
          // we return real unique id of the playlist and replace temporary one
          this.$store.dispatch("setPlaylistCreationData", {
            playlist: newplaylist,
            id: response.data.id,
            timestamp: response.data.timestamp,
          });
          this.$refs["playlistList"].$el.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          this.notify("Playlist created");
          this.$store.dispatch("setPlaylistCreation", false);
        })
        .catch((error) => {
          this.$store.dispatch("setPlaylistCreation", false);
          this.notifyError("Error creating playlist. Please try again later.");
        });
      } else {
        this.notifyError("This object is not playable");
      }
    },
    clickedOutsidePlaylist(event) {
    const target = event.target
    const isOpenButton = target.closest('.open-playlist-btn')
   
      if (isOpenButton) {
        return
      }

      this.showPlaylistDropdown = false;
    },
    clickedOutsideFavs(event) {
      const target = event.target
      const isOpenButton = target.closest('.open-favs-btn')

      if (isOpenButton) {
        return
      }
      this.showFavsDropdown = false;
    },
    clickedOutsideSearch(event) {
      const target = event.target
      const isOpenButton = target.closest('.open-search-btn')

      if (isOpenButton) {
        return
      }
      this.showSearchDropdown = false;
    },
    clickedOutsideTracks(event) {
      const target = event.target
      const isOpenButton = target.closest('.open-tracks-btn')

      if (isOpenButton) {
        return
      }

      this.showTrackDropdown = false;
    },
    clickedOutsideMobilePlayer(event) {
      this.showMobilePlayer = false;
    },
    openAddPlaylist(currentTrack) {
      this.currentTrackToAdd = currentTrack;
      this.showPlaylistDropdown = !this.showPlaylistDropdown;
      this.playlistSearchQuery = "";
      this.isPlaylistLoading = true;
      this.loadingplaylist = false;
      this.visiblePlaylists = this.filterPlaylists().slice(
        0,
        this.itemsPerPage
      );

      this.$forceNextTick(() => {
        this.isPlaylistLoading = false;
      });
    },
    loadMorePlaylists() {
      const start = this.visiblePlaylists.length;
      const end = start + this.itemsPerPage;
      this.visiblePlaylists = this.visiblePlaylists.concat(
        this.filterPlaylists().slice(start, end)
      );
    },
    loadMorePlaylistsMobile() {
      const start = this.visiblePlaylists.length;
      const end = start + this.itemsPerPageMobile;
      this.visiblePlaylists = this.visiblePlaylists.concat(
        this.filterPlaylists().slice(start, end)
      );
    },
    loadMoreTracks() {
      const start = this.visibleTracks.length;
      const end = start + this.itemsPerPage;
      this.visibleTracks = this.visibleTracks.concat(
        this.filterTracks().slice(start, end)
      );
    },
    loadMoreTracksMobile() {
      const start = this.visibleTracks.length;
      const end = start + this.itemsPerPageMobile;
      this.visibleTracks = this.visibleTracks.concat(
        this.filterTracks().slice(start, end)
      );
    },
    loadMoreFavs() {
      const start = this.visibleFavs.length;
      const end = start + this.itemsPerPageFavs;
      this.visibleFavs = this.visibleFavs.concat(
        this.filterFavs().slice(start, end)
      );
    },
    loadMoreFavsMobile() {
      const start = this.visibleFavs.length;
      const end = start + this.itemsPerPageFavsMobile;
      this.visibleFavs = this.visibleFavs.concat(
        this.filterFavs().slice(start, end)
      );
    },
    onScroll(event) {
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMorePlaylists();
      }
    },
    onScrollMobile(event) {
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMorePlaylistsMobile();
      }
    },
    onScrollTracks(event) {
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMoreTracks();
      }
    },
    onScrollTracksMobile(event){
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMoreTracksMobile();
      }
    },
    onScrollFavs(event) {
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMoreFavs();
      }
    },
    onScrollFavsMobile(event) {
      const element = event.target;
      if (
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 1
      ) {
        this.loadMoreFavsMobile();
      }
    },
    openFavs() {
      this.showFavsDropdown = !this.showFavsDropdown;
      this.favsSearchQuery = "";
      this.isFavsLoading = true;
      this.loadingfavs = false;
      this.visibleFavs = this.filterFavs().slice(0, this.itemsPerPageFavs);

      this.$forceNextTick(() => {
        this.isFavsLoading = false;
      });
    },
    openSearch(){
      this.showSearchDropdown = !this.showSearchDropdown;
    },
    openTracklist() {
      this.showTrackDropdown = !this.showTrackDropdown;
      this.trackSearchQuery = "";
      this.isTrackLoading = true;
      this.loadingdata = false;
      this.visibleTracks = this.filterTracks().slice(0, this.itemsPerPage);

      this.$forceNextTick(() => {
        this.isTrackLoading = false;
      });
    },
    toggleTrackInPlaylistExt(playlist, currentTrackToAdd) {
      // EMITOWANIE EVENTU DO PLAYERA
      const trackId = currentTrackToAdd.id;
      if (currentTrackToAdd.playable === 1){
        if (playlist.tracks.includes(trackId)) {
          // Remove track from playlist
          const newtracks = playlist.tracks.filter((id) => id !== trackId);
          if (newtracks.length === 0) {
            this.$store.dispatch("setUserPlaylists", {
              playlists: this.userPlaylists.filter((p) => p.id !== playlist.id),
            });
            this.$store.dispatch("deletePlaylist", {
              token: this.user.token,
              playlistId: playlist.id,
            });
          } else {
            this.$store.dispatch("removeTrackFromPlaylistInternal", {
              playlistId: playlist.id,
              trackId: trackId,
            });
            this.$store.dispatch("removeTrackFromPlaylist", {
              token: this.user.token,
              playlistId: playlist.id,
              trackId: trackId,
            });
          }
        } else {
          // Maximum number of songs in playlist - 150
          // Add track to playlist
          if (playlist.tracks.length >= 150) {
            return;
          }
          this.$store.dispatch("addTrackToPlaylistInternal", {
            playlistId: playlist.id,
            trackId: trackId,
          });
          this.$store.dispatch("addTrackToPlaylist", {
            token: this.user.token,
            playlistId: playlist.id,
            trackId: trackId,
          });
        }
      } else {
        this.notifyError("Trying to add not playable object");
      }
    },
    toggleTrackInPlaylist(playlist) {
      const trackId = this.currentTrackToAdd.id;
      if (playlist.tracks.includes(trackId)) {
        // Remove track from playlist
        const newtracks = playlist.tracks.filter((id) => id !== trackId);
        if (newtracks.length === 0) {
          this.$store.dispatch("setUserPlaylists", {
            playlists: this.userPlaylists.filter((p) => p.id !== playlist.id),
          });
          this.$store.dispatch("deletePlaylist", {
            token: this.user.token,
            playlistId: playlist.id,
          });
        } else {
          this.$store.dispatch("removeTrackFromPlaylistInternal", {
            playlistId: playlist.id,
            trackId: trackId,
          });
          this.$store.dispatch("removeTrackFromPlaylist", {
            token: this.user.token,
            playlistId: playlist.id,
            trackId: trackId,
          });
        }
      } else {
        // Maximum number of songs in playlist - 150
        // Add track to playlist
        if (playlist.tracks.length >= 150) {
          return;
        }
        this.$store.dispatch("addTrackToPlaylistInternal", {
          playlistId: playlist.id,
          trackId: trackId,
        });
        this.$store.dispatch("addTrackToPlaylist", {
          token: this.user.token,
          playlistId: playlist.id,
          trackId: trackId,
        });
      }
    },

    filterPlaylists() {
      if (!this.playlistSearchQuery || this.playlistSearchQuery === "") {
        return this.userPlaylists;
      } else {
        const query = this.playlistSearchQuery.toLowerCase();
        return this.userPlaylists.filter((playlist) =>
          playlist.name.toLowerCase().includes(query)
        );
      }
    },
    filterTracks() {
      if (!this.trackSearchQuery || this.trackSearchQuery === "") {
        return this.tracks.map((track, index) => ({
          ...track,
          originalIndex: index,
        }));
      } else {
        const query = this.trackSearchQuery.toLowerCase();
        return this.tracks
          .map((track, index) => ({ ...track, originalIndex: index }))
          .filter((track) => track.title.toLowerCase().includes(query));
      }
    },
    shuffleTracks() {
      // EMITOWANIE EVENTU DO PLAYERA
      const currentTrack = this.tracks[this.currentTrackIndex];
      const otherTracks = this.tracks.filter(
        (_, index) => index !== this.currentTrackIndex
      );
      this.$store.dispatch("setUserTracks", {
        songs: [currentTrack, ...otherTracks.sort(() => Math.random() - 0.5)],
      });
      this.$store.dispatch("setCurrentTrackIndex", 0);
      this.$refs["tracksList"].$el.scrollTo({ top: 0, behavior: "smooth" });
      this.storeTracks();
      this.notify("Queue shuffled");
    },
    filterFavs() {
      if (!this.favsSearchQuery || this.favsSearchQuery === "") {
        return this.userFavSongs;
      } else {
        const query = this.favsSearchQuery.toLowerCase();
        return this.userFavSongs.filter((fav) =>
          fav.title.toLowerCase().includes(query)
        );
      }
    },
    ifCurrentMusicNow(fav) {
      if (this.currentTrack.id === fav.id) {
        return true;
      }
      return false;
    },
    isPlayingNow(fav) {
      if (this.currentTrack.id === fav.id && this.isPlaying) {
        return true;
      }
      return false;
    },
    notinPlaylists(id) {
      // owner in playlist is not being sent to the user as it has emaila address inside

      for (let i = 0; i < this.userPlaylists.length; i++) {
        for (let j = 0; j < this.userPlaylists[i].tracks.length; j++) {
          if (this.userPlaylists[i].tracks[j] === id) {
            return false;
          }
        }
      }
      return true;
    },

    addToFav(currentTrack) {
      if (currentTrack.playable === 1){
        // EMITOWANIE EVENTU DO PLAYERA
        if (this.userFavSongs.length < 150) {
          this.$store.dispatch("setUserFavSongsPush", currentTrack);
          this.$store
            .dispatch("addUserFavSong", {
              token: this.user.token,
              song: currentTrack.id,
            })
            .then((response) => {
              this.notify("Added to favourites");
            });
        }
      } else {
        this.notifyError("Object is not playable");
      }
    },
    removeFromFav(currentTrack) {
      // EMITOWANIE EVENTU DO PLAYERA
      for (let i = 0; i < this.userFavSongs.length; i++) {
        if (this.userFavSongs[i].id === currentTrack.id) {
          this.$store.dispatch("setUserFavSongsSplice", i);
          this.$store.dispatch("removeUserFavSong", {
            token: this.user.token,
            song: currentTrack.id,
          });
          break;
        }
      }
    },
    notinFav(id) {
      for (let i = 0; i < this.userFavSongs.length; i++) {
        if (this.userFavSongs[i].id === id) {
          return false;
        }
      }
      return true;
    },
    addAllFavsToQueue() {
      // EMITOWANIE EVENTU DO PLAYERA
      for (let i = 0; i < this.userFavSongs.length; i++) {
        if (this.tracks.length >= 150) {
          break;
        }
        this.$store.dispatch("setUserTracksPush", this.userFavSongs[i]);
      }
      this.notify("Favourites added to queue");
      this.storeTracks();
    },
    addtoQueue(fav) {
      if (fav.playable === 1){
        // EMITOWANIE EVENTU DO PLAYERA
        if (this.tracks.length >= 150) {
          this.$store.dispatch("setUserTracksPop");
        }
        this.$store.dispatch("setUserTracksPush", fav);
        this.storeTracks();
        this.notify(fav.title + " added to queue");
      } else {
        this.notifyError("Object is not playable");
      }
    },
    removeFromQueue(fav, index) {
      if (
        index >= 0 &&
        index < this.tracks.length &&
        this.tracks[index].id === fav.id &&
        this.tracks.length > 1
      ) {
        if (index < this.currentTrackIndex) {
          this.$store.dispatch("setUserTracksSplice", index);
          this.$store.dispatch("setCurrentTrackIndex", this.currentTrackIndex - 1);
        } else if (index === this.currentTrackIndex) {
          this.$store.dispatch("setIsMusicLoading", true);
          this.nextTrackRemoval(index);
        } else {
          this.$store.dispatch("setUserTracksSplice", index);
        }
        this.storeTracks();
        this.notify(fav.title + " removed from queue");
      }
    },
    storeTracks() {
      const trackIds = this.tracks.map((track) => track.id);
      this.$store.dispatch("setUserCurrentSongs", {
        token: this.user.token,
        songs: trackIds,
      });
    },
    addFullCreatorToQueue(creator){
        // EMITOWANIE EVENTU DO PLAYERA
        this.$store
        .dispatch("getCreatorTracks", {
          token: this.user.token,
          id: creator,
        })
        .then((response) => {
          const tracks = response.data.tracks;
          for (let i = 0; i < tracks.length; i++) {
            if (i >= 150) {
              break;
            }
            if (tracks[i].playable === 1){
              if (this.tracks.length < 150) {
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              } else {
                this.$store.dispatch(
                  "setUserTracksSplice",
                  this.tracks.length - 1
                );
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              }
            }
          }
          setTimeout(() => {
            this.$store.dispatch("setCurrentTrackIndex", 0);
            this.loadTrack();
            this.notify("Creator random tracks added to queue");
            this.storeTracks();
          }, 10);
        })
        .catch((error) => {
          this.notifyError("Error loading creator tracks. Please try again later.");
        });
    },
    addFullArtistToQueue(artistid){
        // EMITOWANIE EVENTU DO PLAYERA
        this.$store
        .dispatch("getArtistTracks", {
          token: this.user.token,
          id: artistid,
        })
        .then((response) => {
          const tracks = response.data.tracks;
          for (let i = 0; i < tracks.length; i++) {
            if (i >= 150) {
              break;
            }
            if (tracks[i].playable === 1){
              if (this.tracks.length < 150) {
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              } else {
                this.$store.dispatch(
                  "setUserTracksSplice",
                  this.tracks.length - 1
                );
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              }
            }
          }
          setTimeout(() => {
            this.$store.dispatch("setCurrentTrackIndex", 0);
            this.loadTrack();
            this.notify("Artist random tracks added to queue");
            this.storeTracks();
          }, 10);
        })
        .catch((error) => {
          this.notifyError("Error loading artist tracks. Please try again later.");
        });
    },
    addFullAlbumToPlay(album){
        // EMITOWANIE EVENTU DO PLAYERA
        this.$store
        .dispatch("getPlaylistTracks", {
          token: this.user.token,
          trackIds: album.tracks,
        })
        .then((response) => {
          const tracks = response.data.tracks;
          for (let i = 0; i < tracks.length; i++) {
            if (i >= 150) {
              break;
            }
            if (tracks[i].playable === 1){
              if (this.tracks.length < 150) {
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              } else {
                this.$store.dispatch(
                  "setUserTracksSplice",
                  this.tracks.length - 1
                );
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              }
            }
          }
          setTimeout(() => {
            this.$store.dispatch("setCurrentTrackIndex", 0);
            this.loadTrack();
            this.notify("Album added to queue");
            this.storeTracks();
          }, 10);
        })
        .catch((error) => {
          this.notifyError("Error loading album. Please try again later.");
        });
    },
    addFullTracksToPlay(playlist) {
      // EMITOWANIE EVENTU DO PLAYERA
      this.$store
        .dispatch("getPlaylistTracks", {
          token: this.user.token,
          trackIds: playlist.tracks,
        })
        .then((response) => {
          const tracks = response.data.tracks;
          for (let i = 0; i < tracks.length; i++) {
            if (i >= 150) {
              break;
            }
            if (tracks[i].playable === 1){
              if (this.tracks.length < 150) {
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              } else {
                this.$store.dispatch(
                  "setUserTracksSplice",
                  this.tracks.length - 1
                );
                this.$store.dispatch("setUserTracksUnshift", tracks[i]);
              }
            }
          }
          setTimeout(() => {
            this.$store.dispatch("setCurrentTrackIndex", 0);
            this.loadTrack();
            this.notify("Playlist added to queue");
            this.storeTracks();
          }, 10);
        })
        .catch((error) => {
          this.notifyError("Error loading playlist. Please try again later.");
        });
    },
    addAllFavsToEmptyQueue() {
      // EMITOWANIE EVENTU DO PLAYERA
      for (let i = this.userFavSongs.length - 1; i >= 0; i--) {
        if (i >= 150) {
          break;
        }
        if (this.tracks.length < 150) {
          this.$store.dispatch("setUserTracksUnshift", this.userFavSongs[i]);
        } else {
          this.$store.dispatch("setUserTracksSplice", this.tracks.length - 1);
          this.$store.dispatch("setUserTracksUnshift", this.userFavSongs[i]);
        }
      }
      setTimeout(() => {
        this.$store.dispatch("setCurrentTrackIndex", 0);
        this.loadTrack();
        this.storeTracks();
      }, 10);
    },
    playOrPauseSong(fav) {
      if (fav.playable === 1){
        // EMITOWANIE EVENTU DO PLAYERA
        if (this.ifCurrentMusicNow(fav) && this.isPlaying) {
          this.togglePlayPause();
          return;
        } else if (this.ifCurrentMusicNow(fav) && !this.isPlaying) {
          this.togglePlayPause();
          return;
        }

        if (this.tracks.length >= 150) {
          this.$store.dispatch("setUserTracksPop");
        }
        this.$store.dispatch("setUserTracksUnshift", fav);
        setTimeout(() => {
          this.$store.dispatch("setCurrentTrackIndex", 0);
          this.loadTrack();
          this.storeTracks();
        }, 10);
      } else {
        this.notifyError("Object is not playable");
      }
    },
    playOrPauseSongTracks(track, index) {
      if (
        this.ifCurrentMusicNow(track) &&
        this.isPlaying &&
        index === this.currentTrackIndex
      ) {
        this.togglePlayPause();
        return;
      } else if (
        this.ifCurrentMusicNow(track) &&
        !this.isPlaying &&
        index === this.currentTrackIndex
      ) {
        this.togglePlayPause();
        return;
      }

      setTimeout(() => {
        this.$store.dispatch("setCurrentTrackIndex", index);
        this.loadTrack();
      }, 10);
    },
    togglePlayPause() {
      if (this.usehls) {
        if (this.hlsready) {
          if (this.isPlaying) {
            this.audio.pause();
          } else {
            this.audio.play();
          }
          this.$store.dispatch("setIsPlaying", !this.isPlaying);
        } else {
          if (this.isPlaying) {
            this.audio.pause();
          } else {
            this.audio.play();
          }
          this.$store.dispatch("setIsPlaying", !this.isPlaying);
        }
      } else {
        if (this.isPlaying) {
          this.audio.pause();
        } else {
          this.audio.play();
        }
        this.$store.dispatch("setIsPlaying", !this.isPlaying);
      }
    },
    prevTrack() {
      if (this.currentTime > 4) {
        this.currentTime = 0;
        this.audio.currentTime = 0;
      } else {
        setTimeout(() => {
          this.$store.dispatch("setCurrentTrackIndex", ((this.currentTrackIndex - 1 + this.tracks.length) % this.tracks.length));
          this.loadTrack();
        }, 10);
      }
    },
    nextTrack() {
      setTimeout(() => {
        this.$store.dispatch("setCurrentTrackIndex", (this.currentTrackIndex + 1) % this.tracks.length);
        this.loadTrack();
      }, 10);
    },
    nextTrackRemoval(index) {
      setTimeout(() => {
        if (this.currentTrackIndex % (this.tracks.length - 1) === 0) {
          this.$store.dispatch("setCurrentTrackIndex", 0);
          this.$store.dispatch("setUserTracksSplice", index);
          this.loadTrack();
        } else {
          this.$store.dispatch("setUserTracksSplice", index);
          this.$store.dispatch("setCurrentTrackIndex", this.currentTrackIndex % this.tracks.length);
          this.loadTrack();
        }
      }, 10);
    },
    loadPreview(){
              this.$store.dispatch("setCurrentTrackInfo", 1);
              if (this.audio.src !== "") {
                this.audio.pause();
              }

              this.setPreview(true);
              // Brak wsparcia HLS (jesli) to nie problem bo Preview idzie i tak z AAC src kilku sekundowe ta sama jakosc
              this.hlsProblem = false;
              this.geoPassed = false;
              this.geoOwnerOnly = false;
              if (this.usehls) {
                this.loadhlssourceandplay(this.currentTrack.src);
              } else {
                this.loadAndPlay(this.currentTrack);
                this.$store.dispatch("setIsPlaying", true);
              }
    },
    loadPlay(){
            this.setPreview(false);
            this.$store.dispatch("setCurrentTrackInfo", 0);
            if (this.audio.src !== "") {
              this.audio.pause();
            }
            if (this.usehls && this.playHLScheck(this.currentTrack)) {
              this.hlsProblem = false;
              this.geoPassed = false;
              this.geoOwnerOnly = false;
              this.loadhlssourceandplay(this.currentTrack.hlssrc);
            } else if (this.usehls) {
              this.hlsProblem = false;
              this.geoPassed = false;
              this.geoOwnerOnly = false;
              this.loadhlssourceandplay(this.currentTrack.src);
            } else {
              // Odgrywamy backup AAC w domyslnej jakosci 128kbps
              this.geoPassed = false;
              this.hlsProblem = true;
              this.geoOwnerOnly = false;
              this.loadAndPlay(this.currentTrack);
              this.$store.dispatch("setIsPlaying", true);
            }
    },
    loadPlayInit(){
          this.setPreview(false);
          this.$store.dispatch("setCurrentTrackInfo", 0);
          if (this.usehls && this.playHLScheck(this.currentTrack)) {
            this.hlsProblem = false;
            this.geoPassed = false;
            this.geoOwnerOnly = false;
            this.loadhlssource(this.currentTrack.hlssrc);
          } else if (this.usehls) {
            this.hlsProblem = false;
            this.geoPassed = false;
            this.geoOwnerOnly = false;
            this.loadhlssource(this.currentTrack.src);
          } else {
            // Odgrywamy backup AAC w domyslnej jakosci 128kbps LOG and SHOW PROBLEM
            this.hlsProblem = true;
            this.geoPassed = false;
            this.geoOwnerOnly = false;
            this.loadOnly(this.currentTrack);
            this.$store.dispatch("setIsPlaying", false);
          }
    },
    loadPreviewInit(){
      this.$store.dispatch("setCurrentTrackInfo", 1);
          this.hlsProblem = false;
          this.geoPassed = false;
          this.geoOwnerOnly = false;
          this.setPreview(true);

          if (this.usehls) {
            this.loadhlssource(this.currentTrack.src);
          } else {
            this.loadOnly(this.currentTrack);
            this.$store.dispatch("setIsPlaying", false);
          }
    },
    loadTimePassedInit(){
      this.$store.dispatch("setCurrentTrackInfo", 1);
          this.hlsProblem = false;
          this.geoPassed = true;
          this.geoOwnerOnly = false;
          this.setPreview(true);

          if (this.usehls) {
            this.loadhlssource(this.currentTrack.src);
          } else {
            this.loadOnly(this.currentTrack);
            this.$store.dispatch("setIsPlaying", false);
          }
    },
    loadTimePassed(){
      this.$store.dispatch("setCurrentTrackInfo", 1);
              if (this.audio.src !== "") {
                this.audio.pause();
              }
              this.hlsProblem = false;
              this.geoPassed = true;
              this.geoOwnerOnly = false;
              this.setPreview(true);
              
              // Brak wsparcia HLS (jesli) to nie problem bo Preview idzie i tak z AAC src kilku sekundowe ta sama jakosc
              if (this.usehls) {
                this.loadhlssourceandplay(this.currentTrack.src);
              } else {
                this.loadAndPlay(this.currentTrack);
                this.$store.dispatch("setIsPlaying", true);
              }
    },
    loadOnlyForOwner(){
      this.$store.dispatch("setCurrentTrackInfo", 1);
              if (this.audio.src !== "") {
                this.audio.pause();
              }
              this.hlsProblem = false;
              this.geoPassed = false;
              this.geoOwnerOnly = true;
              this.setPreview(true);
              
              // Brak wsparcia HLS (jesli) to nie problem bo Preview idzie i tak z AAC src kilku sekundowe ta sama jakosc
              if (this.usehls) {
                this.loadhlssourceandplay(this.currentTrack.src);
              } else {
                this.loadAndPlay(this.currentTrack);
                this.$store.dispatch("setIsPlaying", true);
              }
    },
    loadOnlyForOwnerInit(){
      this.$store.dispatch("setCurrentTrackInfo", 1);
          this.hlsProblem = false;
          this.geoPassed = false;
          this.geoOwnerOnly = true;
          this.setPreview(true);

          if (this.usehls) {
            this.loadhlssource(this.currentTrack.src);
          } else {
            this.loadOnly(this.currentTrack);
            this.$store.dispatch("setIsPlaying", false);
          }
    },
    async getLocation() {
      // Sprawdzenie, czy Geolocation API jest dostępne
      if (!navigator.geolocation) {
        this.notifyError('Geolocation is not supported by your browser.');
        return;
      }

      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        this.location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
      } catch (err) {
          // Obsługa błędów
          switch (err.code) {
            case err.PERMISSION_DENIED:
              this.notifyError('User denied the request for Geolocation.');
              break;
            case err.POSITION_UNAVAILABLE:
              this.notifyError('Location information is unavailable.');
              break;
            case err.TIMEOUT:
              this.notifyError('The request to get user location timed out.');
              break;
            default:
              this.notifyError('An unknown error occurred.');
          }
      }
    },
    async isInLocation() {
      // Check current location sent from mobile device to the server
      // Get it and in case its matching the boundary, update the currentTrack with the new src
      // It also checks on the server side if geo_time_until is not reached.
      // It checks also if geo_can_play_in_location_non_owner can play or not
      return await new Promise((resolve, reject) => {
        this.getLocation().then(() => {
          if(this.location){
            this.$store.dispatch("getUserLocationForTrack", {
              token: this.user.token,
              latitude: this.location.latitude,
              longitude: this.location.longitude,
              trackId: this.currentTrack.id,
            }).then((response) => {
                if (response.data.inside === 1) {
                  this.currentTrack.src = response.data.src;
                  this.currentTrack.hlssrc = response.data.hlssrc;
                  resolve(true);
                } else {
                  resolve(false);
                }
            }).catch((error) => {
              resolve(false);
            });
          } else {
            resolve(false);
          }
        });
      });
    },
    async loadTrack() {
      if (
        this.currentTrack.streamable === 0 &&
        this.currentTrack.playable === 1
      ) {
        // If its GEO track
        if (this.currentTrack.type === 'geo'){
          if (this.currentTrack.nft_is === 1){
            if (
              this.currentTrack.owner === this.user.creator ||
              this.currentTrack.creator === this.user.creator
              ) {
                this.loadPlay();
            } else {
                const currentTimestamp = new Date().toISOString();
                if (this.currentTrack.geo_time_until === '' || this.currentTrack.geo_time_until >= currentTimestamp){
                const isInside = await this.isInLocation();
                if (isInside){
                  if (this.currentTrack.geo_can_play_in_location_non_owner === 1){
                    this.loadPlay();
                  } else {
                    this.loadOnlyForOwner();
                  }
                } else {
                  this.loadPreview();
                }
              } else {
                this.loadTimePassed();
              }
            }
          } else {
            const currentTimestamp = new Date().toISOString();
            if (this.currentTrack.geo_time_until === '' || this.currentTrack.geo_time_until >= currentTimestamp){
              const isInside = await this.isInLocation();
              if (isInside){
                this.loadPlay();
              } else {
                this.loadPreview();
              }
            } else {
              this.loadTimePassed();
            }
          }
        } else if (this.currentTrack.nft_is === 1) {
          if (
          this.currentTrack.owner === this.user.creator ||
          this.currentTrack.creator === this.user.creator
          ) {
            this.loadPlay();
          } else {
            this.loadPreview();
          }
        } else {
          // Non streamable and playable can be only NFT(Including playable tickets), Geo, GEo NFT, and Private music
          // Private music case that is published=0
          // Gdy private ejst publikowane to albo staje sie stremable = 1, albo nie jest playable, albo staje sie streamable NFT badz non streamable NFT.
          if (this.currentTrack.creator === this.user.creator){
            this.loadPlay();
          } else {
            // This should never happen -> play Access forbidden music
            this.loadPreview();
          }
        }
      } else if (this.currentTrack.streamable === 1 && this.currentTrack.playable === 1) {
        const isSubscribed = this.userSubscribedCreators.includes(
            this.currentTrack.creator
          );
        if (this.currentTrack.nft_is !== 1){
          if (isSubscribed) {
            this.loadPlay();
            return;
          } else {
            if (this.user.level >= this.currentTrack.stream_lvl) {
              this.loadPlay();
            } else {
              this.loadPreview();
            }
          }
        } else {
          if (this.user.level < 3) {
            if (this.currentTrack.creator === this.user.creator){
              this.loadPlay();
            } else {
              if (isSubscribed){
                this.loadPlay();
              } else if (this.currentTrack.owner === this.user.creator){
                this.loadPlay();
              } else {
                if (this.user.level >= this.currentTrack.stream_lvl){
                  this.loadPlay();
                } else {
                  this.loadPreview();
                }
              }
            }
          } else {
            this.loadPlay();
          }
        }
      } else {
        this.notifyError("Object not playable..");
      }
    },
    setPreview(value) {
      this.previewWatching = value;
    },
    loadAndPlay(track) {
      this.switchToNativeAudioAndPlay(track.src);
    },
    loadOnly(track) {
      this.switchToNativeAudioOnly(track.src);
    },
    async loadTrackstart() {
      if (
        this.currentTrack.streamable === 0 &&
        this.currentTrack.playable === 1
      ) {
        // If its GEO track
        if (this.currentTrack.type === 'geo'){
          if (this.currentTrack.nft_is === 1){
            if (
              this.currentTrack.owner === this.user.creator ||
              this.currentTrack.creator === this.user.creator
              ) {
                this.loadPlayInit();
            } else {
              const currentTimestamp = new Date().toISOString();
              if (this.currentTrack.geo_time_until === '' || this.currentTrack.geo_time_until >= currentTimestamp){
                const isInside = await this.isInLocation();
                if (isInside){
                  if (this.currentTrack.geo_can_play_in_location_non_owner === 1){
                    this.loadPlayInit();
                  } else {
                    this.loadOnlyForOwnerInit();
                  }
                } else {
                  this.loadPreviewInit();
                }
              } else {
                this.loadTimePassedInit();
              }
            }
          } else {
            const currentTimestamp = new Date().toISOString();
            if (this.currentTrack.geo_time_until === '' || this.currentTrack.geo_time_until >= currentTimestamp){
              const isInside = await this.isInLocation();
              if (isInside){
                this.loadPlayInit();
              } else {
                this.loadPreviewInit();
              }
            } else {
              this.loadTimePassedInit();
            }
          }
        } else if (this.currentTrack.nft_is === 1) {
          if (
          this.currentTrack.owner === this.user.creator ||
          this.currentTrack.creator === this.user.creator
          ) {
            this.loadPlayInit();
          } else {
            this.loadPreviewInit();
          }
        } else {
          if (this.currentTrack.creator === this.user.creator){
            this.loadPlayInit();
          } else {
            this.loadPreviewInit();
          }
        }
      } else if (this.currentTrack.streamable === 1 && this.currentTrack.playable === 1) {
        const isSubscribed = this.userSubscribedCreators.includes(
            this.currentTrack.creator
          );
        if (this.currentTrack.nft_is !== 1){
          if (isSubscribed) {
            this.loadPlayInit();
            return;
          } else {
            if (this.user.level >= this.currentTrack.stream_lvl) {
              this.loadPlayInit();
            } else {
              this.loadPreviewInit();
            }
          }
        } else {
          if (this.user.level < 3) {
            if (this.currentTrack.creator === this.user.creator){
              this.loadPlayInit();
            } else {
              if (isSubscribed){
                this.loadPlayInit();
              } else if (this.currentTrack.owner === this.user.creator){
                this.loadPlayInit();
              } else {
                if (this.user.level >= this.currentTrack.stream_lvl){
                  this.loadPlayInit();
                } else {
                  this.loadPreviewInit();
                }
              }
            }
          } else {
            this.loadPlayInit();
          }
        }
      } else {
        this.notifyError("Object not playable..");
      }
    },
    seek() {
      this.audio.currentTime = this.currentTime;
      this.seeking = false;
    },
    rewind15() {
      this.currentTime = Math.max(this.audio.currentTime - 15, 0);
      this.audio.currentTime = this.currentTime;
    },
    fastForward15() {
      this.currentTime = Math.min(this.audio.currentTime + 15, this.duration);
      this.audio.currentTime = this.currentTime;
    },
    changeVolume() {
      this.audio.volume = this.volume / 100;
      if (this.volume > 0) {
        this.previousVolume = this.volume;
      }
    },
    mute() {
      this.volume = 0;
      this.audio.volume = 0;
    },
    maxVolume() {
      this.volume = 100;
      this.audio.volume = 1;
    },
    toggleMute() {
      if (this.volume === 0) {
        this.volume = this.previousVolume;
        this.audio.volume = this.previousVolume / 100;
      } else {
        this.previousVolume = this.volume;
        this.volume = 0;
        this.audio.volume = 0;
      }
    },
    toggleRepeat() {
      if (this.repeatMode === "none") {
        this.repeatMode = "one";
      } else if (this.repeatMode === "one") {
        this.repeatMode = "all";
      } else {
        this.repeatMode = "none";
      }
    },
    formatTime(seconds) {
      if (isNaN(seconds) || seconds < 0) {
        return "0:00";
      }
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    },
    updateProgress() {
      if (this.seeking) return;
      this.currentTime = this.audio.currentTime;
      if (this.isPlaying && this.audio.currentTime >= 1) {
        this.$store.dispatch("setIsMusicLoading", false);
        this.queueremoval = false; // Ustawiamy queueremoval na false po odtworzeniu co najmniej 1 sekundy
      } else if (this.isPlaying) {
        this.$store.dispatch("setIsMusicLoading", true);
      } else {
        this.$store.dispatch("setIsMusicLoading", false);
        this.queueremoval = false; // Ustawiamy queueremoval na false po odtworzeniu co najmniej 1 sekundy
      }
    },
    stopupdate() {
      this.seeking = true;
    },
    loadLink(currentTrack) {
      if (currentTrack.type === "muze") {
        if (currentTrack.album === "") {
          window.location.href =
            "https://muze.muzible.com/track/" + currentTrack.id;
        } else {
          window.location.href =
            "https://muze.muzible.com/album/" + currentTrack.album;
        }
      } else if (currentTrack.type === "ticket") {
        window.location.href =
          "https://tickets.muzible.com/ticket/" + currentTrack.id;
      } else if (currentTrack.type === "geo") {
        window.location.href =
          "https://verse.muzible.com/track/" + currentTrack.id;
      } else if (currentTrack.type === "global") {
        if (currentTrack.album === "") {
          window.location.href =
            "https://muze.muzible.com/track/" + currentTrack.id;
        } else {
          window.location.href =
            "https://muze.muzible.com/album/" + currentTrack.album;
        }
      }  else if (currentTrack.type === "podcast") {
        if (currentTrack.album === "") {
          window.location.href =
            "https://muze.muzible.com/episode/" + currentTrack.id;
        } else {
          window.location.href =
            "https://muze.muzible.com/podcast/" + currentTrack.album;
        }
      }
    },
    async emitAndWait() {
      const events = ["c0", "c0ns", "c0p", "s0p", "s0", "s1", "s0f", "s2", "s3"];
      const promises = events.map(event => {
          return new Promise(resolve => {
              this.emitter.emit("getcookies", {route: event, done: resolve});
          });
      });

      await Promise.all(promises); // Czeka na zakończenie wszystkich obietnic
    },
  },
  watch: {},
  created() {
    if (this.user != null) {

      this.emitter.on("playOrPauseSong", (track) => {
        this.playOrPauseSong(track);
      });

      this.emitter.on("addAllFavsToEmptyQueue", () => {
        this.addAllFavsToEmptyQueue();
      });

      this.emitter.on("addtoQueue", (track) => {
        this.addtoQueue(track);
      });

      this.emitter.on("addAllFavsToQueue", () => {
        this.addAllFavsToQueue();
      });

      this.emitter.on("removeFromFav", (track) => {
        this.removeFromFav(track);
      });

      this.emitter.on("addToFav", (track) => {
        this.addToFav(track);
      });

      this.emitter.on("toggleTrackInPlaylistExt", ({playlist, track}) => {
        this.toggleTrackInPlaylistExt(playlist, track);
      });

      this.emitter.on("createNewPlaylist", (track) => {
        this.createNewPlaylist(track);
      });

      this.emitter.on("shuffleTracks", () => {
        this.shuffleTracks();
      });

      this.emitter.on("addFullTracksToPlay", (playlist) => {
        this.addFullTracksToPlay(playlist);
      });

      this.emitter.on("addFullAlbumToPlay", (playlist) => {
        this.addFullAlbumToPlay(playlist);
      });

      this.emitter.on("addFullArtistToQueue", (artist) => {
        this.addFullArtistToQueue(artist);
      });

      this.emitter.on("addFullCreatorToQueue", (creator) => {
        this.addFullCreatorToQueue(creator);
      });

      // get user created playlists (full control)
      this.$store.dispatch("getUserPlaylists", {
        token: this.user.token,
      });

      this.$store.dispatch("getUserExtPlaylists", {
        token: this.user.token,
      });

      this.$store.dispatch("getUserFavSongs", {
        token: this.user.token,
      });

      this.$store.dispatch("getUserSubscribedCreators", {
        token: this.user.token,
      });

      // Dodac opcje w Kolejce -> wygeneruj losowo 20 utworow z ulubionych badz zarekomenduj
      this.$store.dispatch("getUserCurrentSongs", {
        token: this.user.token,
      });
    }
  },
  async mounted() {
    this.initializeHLS();
    await this.emitAndWait();

    // Just tested - works
    //this.emitter.emit("deletecookies", {route: "s1", track:"", creator:""});

    this.loadTrackstart();
    this.audio.addEventListener("loadedmetadata", () => {
      this.duration = this.audio.duration;
    });
    this.audio.addEventListener("timeupdate", this.updateProgress);
    this.audio.addEventListener("ended", () => {
      this.onEnded();
      if (this.repeatMode === "one") {
        this.audio.currentTime = 0;
        this.audio.play();
      } else if (this.repeatMode === "all") {
        this.nextTrack();
      } else {
        this.$store.dispatch("setIsPlaying", false);
      }
    });
    this.audio.addEventListener("play", this.onPlay);
    this.audio.addEventListener("pause", this.onPauseOrStop);
  },
  beforeDestroy() {
    this.audio.removeEventListener("timeupdate", this.updateProgress);
    this.audio.removeEventListener("ended", this.nextTrack);
    if (this.hls) {
      this.hls.destroy();
    }
  },
};
</script>

<style lang="scss">
@use "/src/views/css/styles.scss";

.custom-placeholder-color input::placeholder {
  color: white !important;
  opacity: 1;
}

.playlist-card {
  z-index: 1000 !important;
  bottom: 83px !important;
  background-color: black !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
}

.playlist-card-mobile {
  z-index: 1000 !important;
  bottom: 123px !important;
  right:0px!important;
  background-color: black !important;
  border-radius: 0px!important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-pl {
  z-index: 1000 !important;
  bottom: 83px !important;
  background-color: black !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
}

.playlist-card-pl-mobile {
  z-index: 1000 !important;
  bottom: 123px !important;
  right:0px!important;
  background-color: black !important;
  border-radius: 0px!important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-fav {
  z-index: 1000 !important;
  bottom: 83px !important;
  background-color: black !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
}

.playlist-card-fav-mobile {
  z-index: 1000 !important;
  bottom: 123px !important;
  right:0px!important;
  background-color: black !important;
  border-radius: 0px!important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-search {
  z-index: 1000 !important;
  bottom: 83px !important;
  background-color: #000000 !important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-search-mobile {
  z-index: 1000 !important;
  bottom: 123px !important;
  right:0px!important;
  background-color: #000000 !important;
  border-radius: 0px!important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-tracks {
  z-index: 1000 !important;
  bottom: 83px !important;
  background-color: black !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
}

.playlist-card-tracks-mobile {
  z-index: 1000 !important;
  bottom: 123px !important;
  right:0px!important;
  background-color: black !important;
  border-radius: 0px!important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.playlist-card-noplay {
  cursor: default !important;
  z-index: 1002 !important;
  bottom: 83px !important;
  background-color: black !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid white !important;
  border-left: 1px solid white !important;
}

.playlist-card-noplay-mobile {
  cursor: default !important;
  z-index: 1002 !important;
  bottom: 123px !important;
  right:0px!important;
  border-radius: 0px!important;
  background-color: black !important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top: 1px solid white !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}

.music-player {
  background-color: transparent;
  color: white;
}

.artist-link {
  color: white;
  text-decoration: none;
  font-size: 15px;
}

.artist-link:hover {
  color: white;
  text-decoration: underline;
  text-decoration-color: white;
}

.album-art {
  border-radius: 5px!important;
  border: 1px solid transparent!important;
}

.album-art-mobile {
  border-radius: 5px!important;
  border: 1px solid transparent!important;
}

.album-art2 {
  border-radius: 5px!important;
}

.album-art2-mobile {
  border-radius: 5px!important;
  border: 1px solid transparent!important;
}

.track-info {
  color: white;
  font-size: 15px;
}

.track-title {
  font-weight: bold;
  font-size: 16px;
}

.progress-bar {
  margin-top: 0px;
}

.progress-bar-mobile {
  margin-inline: 0px!important;
  margin-top: 0px;
  border-radius: 0px!important;
  max-height: 20px!important;
}

.progress-bar-mobile .v-slider-track {
  border-radius: 0px!important;
}

.progress-bar-mobile .v-input__details {
  min-height: 0px!important;
  max-height: 0px!important;
  padding: 0px!important;
}


.album-art:hover {
  cursor: pointer!important;
  filter: brightness(1.3)!important;
  border: 1px solid white!important;
  border-radius: 5px;
}

.album-art-mobile:hover {
  border-radius: 5px;
}

.v-card-text {
  padding: 0px !important;
}

.overlay-pl {
  position: relative;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  opacity: 1;
  border: 0px solid black;
  height: 24px;
}

.overlay-pl-mobile {
  position: relative;
  width: 170px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  opacity: 1;
  border: 0px solid black;
  height: 24px;
}

.overlay-text-pl {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: bold !important;
  text-align: center;
}

.album-art-row {
  width: 60px;
  height: 60px;
  aspect-ratio: 1/1;
  border-radius: 5px;
  margin-right: 10px;
  border: 1px solid transparent;
}

.album-art-row:hover {
  cursor: pointer;
  filter: brightness(1.3);
  border: 1px solid white;
  border-radius: 5px;
}

.overlay-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 0px!important;
}
.overlay-icon:hover {
  cursor: pointer!important;
  border: 1px solid white!important;
  border-radius: 5px!important;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

.music-icon {
  animation: pulse 0.6s infinite;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 5px;
}

.simple-icon:hover {
  cursor: pointer;
  filter: brightness(1.2);
  transform: scale(1.2);
}

.loading-spinner {
  position: absolute;
  top: 41%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: transparent;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.3s ease !important;
}

.fade2-enter-from,
.fade2-leave-to {
  opacity: 0 !important;
}

.open-playlist-btn {
  /* This field does absolutely nothing */
  --useless-field: 0;
}
.open-search-btn {
  /* This field does absolutely nothing */
  --useless-field: 0;
}
.open-favs-btn {
  /* This field does absolutely nothing */
  --useless-field: 0;
}
.open-tracks-btn {
  /* This field does absolutely nothing */
  --useless-field: 0;
}

</style>
